/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by chenjia on 2016/9/9.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var slide = __webpack_require__(46);
	    var nav = __webpack_require__(4);
	    var placeholder = __webpack_require__(9);
	    var search = __webpack_require__(12);
	    var gotop = __webpack_require__(47);
	    var priceV2 = __webpack_require__(48);
	    var setUserInfo = __webpack_require__(17);
	    var lazyload = __webpack_require__(2);
	    // var shopcart = require('./unit/shopcart/shopcart');
	    var comment = __webpack_require__(50);
	    var indexV2Module = __webpack_require__(51);
	    var nationalEntryModule = __webpack_require__(56);
	    var floor = __webpack_require__(16);
	
	    slide.slideBox({
	        "data": slide.getImgData("tempHideInput"),
	        "backgroundImg": false,
	        "directBtn": true,
	        "duration": 0.3, //滚动持续时间，单位：秒
	        "direction": 'fadein',
	        "delay": 5, //滚动延迟时间，单位：秒
	        "hideClickBar": true, //不自动隐藏点选按键
	        "clickBarRadius": 10,
	        "width": 1210,
	        "height": 369,
	        "isLazyLoad": false,
	        "id": "slideOne"
	    });
	
	    function addEvent(floorIdx) {
	        var classes = $("[data-idx='" + floorIdx + "']").attr("class");
	        if (classes.indexOf("temai") > -1) {
	            // indexV2Module.addSaleFloorEvent();
	        } else if (classes.indexOf("zhicai") > -1) {
	            lazyload.fn.init();
	            comment.fn.init("indexV2");
	        } else {
	            lazyload.fn.init();
	            priceV2.init();
	        }
	    }
	
	    floor.init(function (floorIdx) {
	        addEvent(floorIdx);
	    });
	
	    nationalEntryModule.init();
	    indexV2Module.init();
	    setUserInfo();
	    search.addSearchEvent();
	    nav.handleNav();
	    placeholder.init();
	    lazyload.fn.init();
	    gotop.goTop();
	    // shopcart.init();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(3);
	
	    var lazyload = {
	        init: function init(opt) {
	            var that = this;
	            var op = {
	                anim: true,
	                root: null //jquery对象,配置后查找当前对象下的img标签
	            };
	            $.extend(op, opt);
	            that.img.init(op);
	        },
	        img: {
	            init: function init(n) {
	                function inViewport(el) {
	                    var scroll_top = void 0;
	                    if (document.documentElement && document.documentElement.scrollTop) {
	                        scroll_top = document.documentElement.scrollTop;
	                    } else if (document.body) {
	                        scroll_top = document.body.scrollTop;
	                    }
	
	                    var top = scroll_top;
	                    var btm = scroll_top + document.documentElement.clientHeight;
	                    var elTop = $(el).offset().top;
	
	                    var elBtm = elTop + $(el).height();
	                    return elBtm >= top - 300 && elTop <= btm + 300;
	                }
	
	                $(window).scroll(function () {
	                    var lazyObj = $("img.lazy[data-original]").not("[loaded]");
	                    if (n.root != null) {
	                        lazyObj = n.root.find("img.lazy[data-original]").not("[loaded]");
	                    }
	                    lazyObj.each(function (index, node) {
	                        var $this = $(this);
	                        if ($this.hasClass('hideImg')) {
	                            return;
	                        }
	                        if (!inViewport(this)) {
	                            return;
	                        }
	                        act($this);
	                    });
	                }).trigger('scroll');
	
	                function act(_self) {
	                    var img = new Image();
	                    var original = _self.attr('data-original');
	
	                    if (original.indexOf("360buyimg") > -1) {
	                        if (Config.isSupportWebP && _self.hasClass("useWebP")) {
	                            if (original.indexOf(".jpg") > 0) {
	                                original = original.replace(/.jpg$/, ".jpg!q90.webp");
	                            } else if (original.indexOf(".png") > 0) {
	                                original = original.replace(/.png$/, ".png.webp");
	                            }
	                        } else {
	                            original = original.replace(/.jpg$/, ".jpg!q90");
	                        }
	                    }
	
	                    img.onload = function () {
	                        _self.attr('src', original).removeClass('lazy');
	                        n.anim && _self.css({
	                            opacity: .2
	                        }).animate({
	                            opacity: 1
	                        }, 280);
	                    };
	                    try {
	                        if (original) {
	                            img.src = original;
	                        }
	                    } catch (error) {}
	
	                    _self.attr('loaded', true);
	                }
	            }
	        }
	    };
	    exports.fn = lazyload;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = {
	        debug: false,
	        isSubmited: false,
	        isSupportWebP: false,
	        isIE: function isIE() {
	            //ie?
	            if (!!window.ActiveXObject || "ActiveXObject" in window) return true;else return false;
	        }
	    };
	
	    Config.serviceInterface = {
	        getTime: "//specials.jd.hk/getTime.do",
	        getTrackInfo: "//home.jd.hk/asyn/getTrackInfo.do",
	        getIdNumber: "//home.jd.hk/asyn/checkOrderIdCard.do",
	        confirmReceipt: "//home.jd.hk/asyn/confirmReceipt.do",
	        cancelOrder: "//home.jd.hk/asyn/cancelOrder.do",
	        deleteCoupon: "//home.jd.hk/asyn/delUserCoupon.do?",
	        getCouponCount: "//home.jd.hk/coupon/count.do",
	        getOrderState: "//club.jd.com/mycomments/getListOrderHandleState.action",
	        getOrderState_local: "//home.jd.hk/asyn/getOrderHandleState.do",
	        deleteOrder: "//home.jd.hk/asyn/recycleOrder.do",
	        cancelFollow: "//home.jd.hk/asyn/unfollow.do",
	        ajaxCancelFollowShop: "//home.jd.hk/asyn/unFollowByshopId.do",
	        getHistoricEmail: "//home.jd.hk/asyn/storeNotifyBaseInfo.do",
	        sendStoreNotifyEmail: "//home.jd.hk/asyn/storeNotify.do",
	        addToCart: "//cart.jd.com/gate.action",
	        loadShopSkus: "//diviner.jd.com/diviner",
	        getCitys: "//home.jd.hk/asyn/getCitys.do",
	        getCountries: "//home.jd.hk/asyn/getCountries.do",
	        getTowns: "//home.jd.hk/asyn/getTowns.do",
	        deleteAddressById: "//home.jd.hk/asyn/delAddressById.do",
	        updateAddress: "//home.jd.hk/asyn/updateAddress.do",
	        insertAddress: "//home.jd.hk/asyn/insertAddressInfo.do",
	        getAddressNameMap: "//home.jd.hk/asyn/getaddressNameMap.do",
	        setDefaultAddress: "//home.jd.hk/asyn/setDefaultAdress.do",
	        loadRecmdGoods: "//diviner.jd.com/diviner",
	        loadRecmdShops: "//home.jd.hk/asyn/getrecommendShopsByshopId.do",
	        getCommentsCnt: "//home.jd.hk/comment/count.do",
	        getCommentByguid: "//home.jd.hk/comment/getByGuid.do",
	        getQiangNum: "//qiangsite.jd.com/qiangnum/mgets",
	        getFoodMsProcess: "//qiangsite.jd.com/qiangnum/mgets",
	        getPromoById: "//grocer.jd.hk/getPromoById.do",
	        grocerAddCart: "//grocer.jd.hk/addCart.do",
	        getSkuPromoTag: "//grocer.jd.hk/getSkuPromoTag.do",
	        getShopPromoTag: "//grocer.jd.hk/getShopPromoTag.do",
	        getFollowingCnt: "//home.jd.hk/follow/count.do",
	        getPromotingskus: "//home.jd.hk/follow/getPromoProduct.do",
	        getCartNum: "//hongkong.jd.com/getCartNum.do",
	        getBrowserHistory: "//hongkong.jd.com/getBrowseHistory.do",
	        getCommentByskuIds: "//zy.jd.hk/getCommentCountBySkuId.html",
	        getTypeBySkuId: "//search.jd.hk/getTypeBySkuId.do",
	        saveIdCard: "/asyn/storeReceiverIdCard.do",
	        validateUploadName: "//home.jd.hk/clearanceUpload/validateUploadName.do",
	        idCardUploadSync: "//jdw.jd.hk/clearance/uploadStatus.do",
	        //getStockBySkuId: '//search.jd.hk/getStockBySkuId.do',
	        getCategory: "//search.jd.hk/getCategory.do",
	        getGoodRateBySkuId: "//zy.jd.hk/getGoodRateBySkuId.html",
	        delayReceipt: "//home.jd.hk/asyn/delayReceipt.do",
	        getComponentInfo: "//jicc-web.jd.com/api/component/getComponentInfo/pc",
	        uploadImage: "//jicc-web.jd.com/api/component/uploadImage/pc",
	        saveImage: "//jicc-web.jd.com/api/component/save/pc",
	        doGrant: "//home.jd.hk/asyn/idCardAuth/doGrant.do",
	        getStatus: "//home.jd.hk/asyn/idCardAuth/status.do",
	        getSupplyChainTrace: "//home.jd.hk/asyn/supplyChainTrace.do",
	
	        getOrderPerson: "//home.jd.hk/order/getPurchaserInfo.html",
	        getOrderEnterPerson: "//home.jd.hk/order/verifyPurchaserInfo.html",
	        getOrderPersonSend: "//home.jd.hk/order/submitPurchaserInfo.html",
	
	        getShopServer: "//chat1.jd.com/api/checkChat?",
	
	        //预售付款：定金阶段、全款阶段、尾款（不支持优惠券）
	        presaleOrderOne: "//trade.jd.hk/presale/getOrderCashierLink.action?",
	
	        //预售尾款支持优惠券
	        presaleOrderCoupon: "//trade.jd.hk/presale/end.action?",
	        //商户入驻
	        applyVender: "//www.jd.hk/cooperation/applySellerApplyResidence.do",
	        applyFacilitator: "//www.jd.hk/cooperation/applyFacilitatorResidence.do",
	        uploadFacilitator: "//www.jd.hk/cooperation/upload.do",
	        submitSuccess: "//www.jd.hk/cooperation/submitSuccess.do",
	        submitSuccessEn: "//www.jd.hk/cooperation/submitSuccessEn.do",
	        uploadFacilitatorFile: "//www.jd.hk/cooperation/uploadFile.do"
	
	    };
	
	    Config.validators = {
	        email: {
	            regExp: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	            errorMsg: "请填写正确的邮箱地址"
	        },
	        phoneNum: {
	            regExp: /^1[3|4|5|7|8]\d{9}$/,
	            errorMsg: "手机号码格式不正确"
	        },
	        idCard: {
	            regExp: /^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/,
	            errorMsg: "请填写正确的身份证号码"
	        },
	        staticPhone: {
	            regExp: /^((^[0-9 -]+$)|(1[34578]\d{9}))$/,
	            errorMsg: "请填写正确的固定电话"
	        },
	        receiver: {
	            errorMsg: "请填写正确的收货人"
	        },
	        validateAddressDetail: {
	            errorMsg: "详细地址不能为空"
	        },
	        money: {
	            regExp: /^\d+(\.\d+)?$/,
	            errorMsg: "金额格式不正确"
	        },
	        url: {
	            regExp: /^((https|http|ftp|rtsp|mms)?:\/\/)+[A-Za-z0-9]+\.[A-Za-z0-9]+[\/=\?%\-&_~`@[\]\':+!]*([^<>\"\"])*$/,
	            errorMsg: "链接格式不正确"
	        },
	        number: {
	            regExp: /^\d+$/,
	            errorMsg: "数字格式不正确"
	        }
	    };
	
	    module.exports = Config;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var lazyLoad = __webpack_require__(2);
	
	var handleNav = function handleNav() {
	    $("#categorys-2014").find(".dd-inner .item").bind("mouseenter", function (e) {
	        e.preventDefault();
	        $(this).addClass("hover").siblings().removeClass("hover");
	
	        $(this).find(".sub-menu .lazy").removeClass("hideImg");
	
	        var subObj = $(this).find(".sub-menu");
	        var offsetFocus = $("#categorys-2014 .dd").offset().top;
	        var itemOffsetTop = $(this).offset().top;
	        var moveY = itemOffsetTop - offsetFocus - 2;
	
	        subObj.css("top", -moveY);
	        lazyLoad.fn.init({ "root": $(this) });
	    });
	
	    $("#navitems-2014").bind("mouseenter", function (e) {
	        e.preventDefault();
	        unHover();
	    });
	
	    $("#categorys-2014").bind("mouseleave", function (e) {
	        e.preventDefault();
	        unHover();
	    });
	
	    function unHover() {
	        $("#categorys-2014").find(".dd-inner .item").removeClass("hover");
	    }
	};
	
	var control = {
	    init: function init() {
	        var self = this;
	        self.handleShop();
	        self.loadMenu();
	        self.changeRoot();
	    },
	    loadMenu: function loadMenu() {
	        var self = this;
	        $("#categorys-2014 .dd").remove();
	        $(".leaf-nav").remove();
	        $.ajax({
	            type: 'POST',
	            url: "//www.jd.hk/header/getData.do",
	            dataType: "jsonp",
	            success: function success(data) {
	                self.reunderNav(data);
	                self.hover();
	                handleNav();
	            }
	        });
	    },
	    reunderNav: function reunderNav(data) {
	        var self = this;
	
	        if (typeof queryParam != "undefined" && queryParam.keyword) {
	            $("#key").val(html_decode(queryParam.keyword)).attr("placeholder", data.indexTopSearchPlaceHolderText[0].text);
	        } else {
	            $("#key").val(data.indexTopSearchPlaceHolderText[0].text).attr("placeholder", data.indexTopSearchPlaceHolderText[0].text);
	        }
	
	        var tplNavMenu = __webpack_require__(5);
	        var navMenuHtml = self.render(data, tplNavMenu);
	        $("#categorys-2014 .dt").after(navMenuHtml);
	
	        var tplNavItem = __webpack_require__(6);
	        var navItemHtml = self.render(data, tplNavItem);
	        $("#navitems-2014").html(navItemHtml);
	
	        var tplHotKey = __webpack_require__(7);
	        var hotKeyHtml = self.render(data, tplHotKey);
	        $("#hotwords-2014").html(hotKeyHtml);
	
	        function html_decode(str) {
	            var s = "";
	            if (str.length == 0) return "";
	            s = str.replace(/&lt;/g, "<");
	            s = s.replace(/&gt;/g, ">");
	            s = s.replace(/&apos;/g, "\'");
	            s = s.replace(/&quot;/g, "\"");
	            s = s.replace(/&#92;/g, "\\");
	            s = s.replace(/&amp;/g, "&");
	            return s;
	        }
	    },
	    changeRoot: function changeRoot() {
	        $(".leaf-nav").each(function () {
	            $(this).insertAfter($("#nav-2014 .w"));
	        });
	    },
	    hover: function hover() {
	        $("#categorys-2014").unbind("mouseenter").bind("mouseenter", function (e) {
	            $(this).find(".dd").css("display", "block");
	            $(this).addClass("hover");
	        }).bind("mouseleave", function () {
	            $(this).find(".dd").css("display", "none");
	            $(this).removeClass("hover");
	        });
	
	        $("#categorys-2014 .dd").unbind("mouseenter").bind("mouseenter", function () {
	            $(this).css("display", "block");
	        }).bind("mouseleave", function () {
	            setTimeout(function () {
	                if ($("#categorys-2014").hasClass("hover")) {
	                    return false;
	                }
	                $(this).css("display", "none");
	            }, 200);
	        });
	    },
	    handleShop: function handleShop() {
	        $(".shopHeaderArea .shopInfo").bind("mouseenter", function () {
	            $(".ratLayer").css("display", "block").addClass("isIn");
	        }).bind("mouseleave", function () {
	            $(".ratLayer").removeClass("isIn");
	            setTimeout(function () {
	                if ($(".ratLayer").hasClass("isIn")) {
	                    return false;
	                }
	                $(".ratLayer").css("display", "none");
	            }, 200);
	        });
	
	        $(".ratLayer").bind("mouseenter", function () {
	            $(".ratLayer").addClass("isIn");
	        });
	
	        $(".ratLayer").bind("mouseleave", function () {
	            $(this).css("display", "none");
	        });
	    },
	    render: function render(data, tpl) {
	        var render = template.compile(tpl.tpl);
	        return render(data);
	    }
	};
	
	exports.handleNav = handleNav;
	exports.control = control;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	var tpl = "\n    <div class=\"dd\" style=\"display: none;\">\n        <div class=\"dd-inner\">\n            <% for(i = 0; i < mainCategory.length; i ++) {%>\n            <div class=\"item\">\n                <h3>\n                    <i class=\"<%=mainCategory[i].directoryIconV2%>\"></i>\n                    <a <% if(mainCategory[i].linkText && mainCategory[i].linkText != \"javascript:;\") { %> class=\"link\" href=\"<%=mainCategory[i].linkText%>\" target=\"_blank\" <% } %>><%=mainCategory[i].text%></a>\n                    <% if(mainCategory[i].imgLogo && mainCategory[i].imgLogo != \"\") { %>\n                        <img src=\"<%=mainCategory[i].imgLogo%>\" class=\"cat-icon\">\n                    <% } %>\n                    <b class=\"arrow-right\"></b>\n                </h3>\n                <% if(mainCategory[i].mainTextLink) {%>\n                    <% for(j = 0; j < mainCategory[i].mainTextLink.length; j++) {%>\n                        <h4><a target=\"_blank\" href=\"<%=mainCategory[i].mainTextLink[j].linkText%>\"><%=mainCategory[i].mainTextLink[j].text%></a></h4>\n                    <%}%>\n                <%}%>\n                <div class=\"sub-menu\">\n                    <div class=\"sub-list\">\n                        <% if(mainCategory[i].popTwoCategory) { %>\n                            <% for(k=0; k<mainCategory[i].popTwoCategory.length; k++) { %>\n                                <dl class=\"slBlock\">\n                                    <dt class=\"liTitle\">\n                                        <a href=\"<%=mainCategory[i].popTwoCategory[k].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-p<%=k+1%>\"><%=mainCategory[i].popTwoCategory[k].text%></a>\n                                    </dt>\n                                    <% if(mainCategory[i].popTwoCategory[k].popThreeCategory) { %>\n                                        <% for(l=0; l<mainCategory[i].popTwoCategory[k].popThreeCategory.length; l++) { %>\n                                            <dd class=\"liItem \">\n                                                <a href=\"<%=mainCategory[i].popTwoCategory[k].popThreeCategory[l].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-p<%=k+1%>-<%=l+1%>\"><%=mainCategory[i].popTwoCategory[k].popThreeCategory[l].text%></a>\n                                            </dd>\n                                        <% } %>\n                                    <% } %>\n                                    <span class=\"clr\"></span>\n                                </dl>\n                                <% if(k != mainCategory[i].popTwoCategory.length-1) {%>\n                                    <div class=\"split\"></div>\n                                <% } %>\n                            <% } %>\n                        <% } %>\n                    </div>\n                    <div class=\"sub-right\">\n                        <% if(mainCategory[i].categoryRecommendBrand) { %>\n                            <div class=\"sr-mask <% if(mainCategory[i].categoryChannelLink || mainCategory[i].categoryRecommendBrand.length < 9) { %>normal<% } else { %>large<% } %>\"></div>\n                            <ul class=\"sub-brands clearfix\">\n                                <% for(j=0; j<mainCategory[i].categoryRecommendBrand.length; j++) { %>\n                                    <% if(mainCategory[i].categoryChannelLink) {%>\n                                        <% if(j < 8) { %>\n                                            <li>\n                                                <a href=\"<%=mainCategory[i].categoryRecommendBrand[j].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>\">\n                                                    <img src=\"//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif\" data-original=\"<%=mainCategory[i].categoryRecommendBrand[j].imgLogo%>\" class=\"lazy\">\n                                                </a>\n                                            </li>\n                                        <% } %>\n                                    <% } else { %>\n                                        <li>\n                                            <a href=\"<%=mainCategory[i].categoryRecommendBrand[j].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>\">\n                                                <img src=\"//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif\" data-original=\"<%=mainCategory[i].categoryRecommendBrand[j].imgLogo%>\" class=\"lazy\">\n                                            </a>\n                                        </li>\n                                    <% } %>\n                                <% } %>\n                            </ul>\n                            <ul class=\"sub-brands-link clearfix\">\n                                <% for(j=0; j<mainCategory[i].categoryRecommendBrand.length; j++) { %>\n                                    <% if(mainCategory[i].categoryChannelLink) {%>\n                                        <% if(j < 8) { %>\n                                            <li>\n                                                <a href=\"<%=mainCategory[i].categoryRecommendBrand[j].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>\"></a>\n                                            </li>\n                                        <% } %>\n                                    <% } else { %>\n                                        <li>\n                                            <a href=\"<%=mainCategory[i].categoryRecommendBrand[j].linkText%>\" target=\"_blank\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-b<%=j+1%>\"></a>\n                                        </li>\n                                    <% } %>\n                                <% } %>\n                            </ul>\n                        <% } %>\n                        <% if(mainCategory[i].categoryChannelLink) { %>\n                            <% for(j=0; j<mainCategory[i].categoryChannelLink.length; j++) { %>\n                                <a target=\"_blank\" href=\"<%=mainCategory[i].categoryChannelLink[0].linkText%>\">\n                                    <img src=\"//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif\" data-original=\"<%=mainCategory[i].categoryChannelLink[0].actImg%>\" class=\"sub-ad lazy\" clstag=\"firsttype|keycount|jdworldwidev2|fl<%=i+1%>-ad\">\n                                </a>\n                            <% } %>\n                        <% } %>\n                    </div>\n                </div>\n            </div>\n            <%}%>\n        </div>\n    </div>\n";
	exports.tpl = tpl;

/***/ }),
/* 6 */
/***/ (function(module, exports) {

	"use strict";
	
	var tpl = "\n<ul>\n    <% if(hnNavigationBar) { %>\n        <% for(i=0; i<hnNavigationBar.length; i++) { %>\n            <li clstag=\"firsttype|keycount|jdworldwide|nav<%=i+1%>\">\n                <a target=\"_blank\" class=\"rNav rNav-<%=hnNavigationBar[i].navId%>\" nav-idx=\"<%=hnNavigationBar[i].navIdx%>\" href=\"<%=hnNavigationBar[i].linkText%>\">\n                    <% if(hnNavigationBar[i].text && hnNavigationBar[i].text != \"\") { %>\n                        <%=hnNavigationBar[i].text%>\n                        <% if(hnNavigationBar[i].imgLogo) { %> \n                            <img src=\"<%=hnNavigationBar[i].imgLogo%>\" class=\"nav-icon\"> \n                        <% } %>\n                    <% } else { %>\n                        <img src=\"<%=hnNavigationBar[i].actImg%>\" class=\"nav-logo\">\n                    <% } %>\n                </a>\n            </li>\n        <% } %>\n    <% } %>\n</ul>\n";
	exports.tpl = tpl;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tpl = '<% if(indexTopSearchKeyWords) { %>' + '<% for(i=0; i<indexTopSearchKeyWords.length; i++) { %>' + '<a href="<%=indexTopSearchKeyWords[i].linkText%>" target="_blank" class="style-red"><%=indexTopSearchKeyWords[i].text%></a>' + '<% } %>' + '<% } %>';
	    exports.tpl = tpl;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	
	    var originalColor = [];
	
	    function isPlaceholder() {
	        var input = document.createElement('input');
	        return 'placeholder' in input;
	    }
	
	    function changeToOriginalColor(self) {
	        var index = $(self).index();
	        var color = originalColor[$(self).index()];
	        $(self).css('color', color);
	    }
	
	    exports.init = function (defaultColor) {
	        defaultColor = defaultColor || "#666";
	        var texts = $(':text');
	        if (!isPlaceholder()) {
	            var len = texts.length;
	            for (var i = 0; i < len; i++) {
	                var self = texts[i];
	                var placeholder = $(self).attr('placeholder');
	                if ($(self).val() == "" && placeholder != null) {
	                    $(self).val(placeholder);
	                    originalColor[i] = $(self).css('color');
	                    $(self).css('color', defaultColor);
	                }
	            }
	        }
	
	        texts.focus(function () {
	            if ($(this).attr('placeholder') != null && $(this).val() == $(this).attr('placeholder')) {
	                $(this).val('');
	                changeToOriginalColor(this);
	            }
	        }).blur(function () {
	            if ($(this).attr('placeholder') != null && ($(this).val() == '' || $(this).val() == $(this).attr('placeholder')) && !$(this).hasClass("shutdown")) {
	                $(this).val($(this).attr('placeholder'));
	                $(this).css('color', defaultColor);
	            }
	        });
	    };
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var priceModel = {
	        ajaxGetPrice: function ajaxGetPrice(data, _success, error) {
	            $.ajax({
	                url: '//p.3.cn/prices/mgets',
	                data: data,
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success)) {
	                        _success(data);
	                    }
	                }
	            });
	        },
	        getDiscount: function getDiscount(newPrice, oldPrice) {
	            var newPrice = newPrice * 10000;
	            var oldPrice = oldPrice * 10000;
	            var result = newPrice / oldPrice;
	
	            var discount = Math.ceil(Math.floor(result * 1000) / 10) / 10;
	            if (discount > 9.9) {
	                discount = "";
	            } else if (discount < 0.1) {
	                discount = 0.1;
	            } else {
	                discount = discount.toFixed(1);
	                if (discount.substring(discount.length - 1, discount.length) == "0") {
	                    discount = discount.substring(0, discount.length - 2);
	                }
	            }
	
	            return discount;
	        },
	        formatPrice: function formatPrice(price) {
	            price = price || "";
	            var arr = price.split(".");
	            if (arr.length == 2) {
	                if (arr[1] == "00") {
	                    return arr[0];
	                } else if (arr[1] == "0000") {
	                    return arr[0];
	                } else if (arr[1].indexOf("0") == arr[1].length) {
	                    return price.substring(0, price.length);
	                } else {
	                    return price;
	                }
	            } else {
	                return price;
	            }
	        }
	    };
	    module.exports = priceModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(3);
	
	    var search = function search() {};
	
	    search.prototype.addSearchEvent = function () {
	        $("#search-2014 .form button, #nav-mygb .form button").unbind("click").bind("click", function () {
	            var keyword = $(this).parent().find("input").attr("id");
	            doSearch(keyword);
	        });
	
	        $("#search-2014 .form input, #nav-mygb .form input").unbind("keydown").bind("keydown", function (event) {
	            if (event.keyCode == 13) {
	                doSearch($(this).attr("id"));
	            }
	        });
	    };
	
	    function doSearch(sNodeId) {
	        var sUrl,
	            sUrl_T = "//search.jd.com/Search?keyword={keyword}&enc={enc}{additional}";
	        var sAdditionalSearch = search.additinal || "";
	        var oKeyTextN = document.getElementById(sNodeId);
	        var sSelKeyValue = oKeyTextN.value;
	        sSelKeyValue = sSelKeyValue.replace(/^\s*(.*?)\s*$/, "$1");
	        if (sSelKeyValue.length > 100) {
	            sSelKeyValue = sSelKeyValue.substring(0, 100);
	        }
	        if ("" == sSelKeyValue) {
	            window.location.href = window.location.href;
	            return;
	        }
	        var iSearchType = 0;
	        if ("undefined" != typeof window.pageConfig && "undefined" != typeof window.pageConfig.searchType) {
	            iSearchType = window.pageConfig.searchType;
	        }
	        var sCIdParamKey_T = "&cid{level}={cid}";
	        var sCId = "string" == typeof search.cid ? search.cid : "";
	        var sCLevel = "string" == typeof search.cLevel ? search.cLevel : "";
	        var sEvVal = "string" == typeof search.ev_val ? search.ev_val : "";
	        switch (iSearchType) {
	            case 8:
	                sUrl_T = "//search.jd.hk/Search?keyword={keyword}&enc=utf-8";
	                break;
	            default:
	                break;
	        }
	        if ("string" == typeof sCId && "" != sCId && "string" == typeof sCLevel) {
	            var reLevel = /^(?:[1-8])?([1-3])$/;
	            if ("-1" == sCLevel) {
	                sCLevel = "";
	            } else {
	                if (reLevel.test(sCLevel)) {
	                    sCLevel = RegExp.$1;
	                } else {
	                    sCLevel = "";
	                }
	            }
	        }
	        sSelKeyValue = encodeURIComponent(sSelKeyValue);
	        sUrl = sUrl_T.replace(/\{keyword}/, sSelKeyValue);
	        sUrl = sUrl.replace(/\{enc}/, 'utf-8');
	        if (Config.isSubmited == false) {
	            setTimeout(function () {
	                Config.isSubmited = false;
	                window.location.href = sUrl;
	            }, 10);
	            Config.isSubmited = true;
	        }
	    }
	
	    module.exports = new search();
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var scrollTimeout = -1;
	    var resizeTimeout = -1;
	
	    var floorArray = {
	        el: []
	    };
	
	    $(".lazy-fl").each(function () {
	        if (!$(this).hasClass("load-done")) {
	            floorArray.el.push($(this));
	        }
	    });
	
	    exports.init = function (callback) {
	        $(window).bind("scroll", function () {
	            clearTimeout(scrollTimeout);
	            scrollTimeout = setTimeout(function () {
	                loadFloor(callback);
	            }, 100);
	        });
	        $(window).bind("resize", function () {
	            clearTimeout(resizeTimeout);
	            resizeTimeout = setTimeout(function () {
	                loadFloor(callback);
	            }, 100);
	        });
	        $(document).trigger("scroll");
	    };
	
	    function loadFloor(callback) {
	        for (var i = 0; i < floorArray.el.length; i++) {
	            if (!inViewport(floorArray.el[i])) {
	                continue;
	            }
	            var floorIdx = floorArray.el[i].attr("data-idx");
	            renderFloor(floorIdx);
	
	            floorArray.el.splice(i, 1);
	
	            if ($.isFunction(callback)) {
	                callback(floorIdx);
	            }
	        }
	    }
	
	    function inViewport(el) {
	        var scroll_top;
	        if (document.documentElement && document.documentElement.scrollTop) {
	            scroll_top = document.documentElement.scrollTop;
	        } else if (document.body) {
	            scroll_top = document.body.scrollTop;
	        }
	
	        var top = scroll_top;
	        var btm = scroll_top + document.documentElement.clientHeight;
	        var elTop = $(el).offset().top;
	
	        var elBtm = elTop + $(el).height();
	        if (elBtm >= top - 500 && elTop <= btm + 500) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	
	    function renderFloor(floorIdx) {
	        var floorHtml = $("#lazy-floor-" + floorIdx).html();
	        $("[data-idx='" + floorIdx + "']").addClass("load-done").html(floorHtml);
	        $("#lazy-floor-" + floorIdx).remove();
	    }
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    /**
	     * @获取用户信息并更新在顶栏个人信息
	     */
	    var setUserInfo = function setUserInfo(options) {
	        options = $.extend({
	            el: $("#new-ttbar-login"),
	            callback: null
	        }, options || {});
	
	        var getHttp = function getHttp() {
	            return 'https:' == document.location.protocol ? 'https://' : 'http://';
	        };
	
	        $.ajax({
	            url: getHttp() + "passport.jd.com/new/helloService.ashx", //接口人:穆永俊
	            dataType: "jsonp",
	            scriptCharset: "GBK",
	            success: function success(data) {
	                if (!data) {
	                    return false;
	                }
	
	                //更新顶栏个人信息
	                if (data.info) {
	                    var infoHk = data.info;
	                    if (data.info.indexOf("jd.com") > -1) {
	                        infoHk = data.info.replace(/home.jd.com/g, "home.jd.hk");
	                    }
	                    // 用全球购sso更换base中的login方法
	                    if (data.info.indexOf('login()') > -1) {
	                        infoHk = data.info.replace(/login\(\)/g, "newLogin()");
	                    }
	                    options.el.html(infoHk);
	                }
	                var _callback = function callback() {
	                    clearTimeout(timer);
	                    if ($.isFunction(options.callback)) {
	                        options.callback(data);
	                    }
	                    // 执行完一次后清空
	                    _callback = $.noop;
	                };
	                // 防止sso 有链接异常，造成callback不执行
	                var timer = setTimeout(function () {
	                    _callback();
	                }, 2000);
	
	                //更新其它域名cookies
	                if (data.sso) {
	                    var len = data.sso.length;
	                    $.each(data.sso, function (i, k) {
	                        $.getJSON(k).complete(function () {
	                            if (--len == 0) {
	                                _callback();
	                            }
	                        });
	                    });
	                } else {
	                    _callback();
	                }
	            }
	        });
	    };
	
	    module.exports = setUserInfo;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(3);
	    var ticker = __webpack_require__(22);
	    var timeModel = {
	        ajaxGetTime: function ajaxGetTime(data, _success, error) {
	            $.ajax({
	                url: Config.serviceInterface.getTime,
	                data: {},
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success)) {
	                        _success(data);
	                    }
	                }
	            });
	        },
	        secondcount: function secondcount(options) {
	            //默认参数
	            var defaults = {
	                timer: 1000,
	                step: 1
	            };
	            var settings = $.extend(defaults, options || {});
	            var step = settings.step || 1;
	            var timer = settings.timer || 1000;
	            var that = this;
	            that.ajaxGetTime(null, function (data) {
	                var timeNow = new Date(data.timeNow);
	                $('.cdtime').each(function () {
	                    var self = $(this);
	                    var endTime = self.attr('endTime');
	                    var duringSecond = (endTime - timeNow.getTime()) / 1000;
	                    self.attr('secondcount', parseInt(duringSecond));
	                });
	                //
	
	                $('.payTime em').each(function () {
	                    var self = $(this);
	                    var orderTime = self.attr('order_time');
	                    var duringSecond = (30 * 60 * 1000 - (timeNow.getTime() - orderTime)) / 1000;
	                    self.attr('secondcount', parseInt(duringSecond));
	                });
	                ticker.init({
	                    "step": step,
	                    "timer": timer
	                });
	            });
	        },
	
	        calculateSecondCount: function calculateSecondCount(options) {
	            //默认参数
	            var defaults = {
	                timer: 1000,
	                step: 1
	            };
	            var settings = $.extend(defaults, options || {});
	
	            //timer: 设置倒计时定时器时间，默认1000ms
	            var step = settings.step || 1;
	            var timer = settings.timer || 1000;
	            var that = this;
	            that.ajaxGetTime(null, function (data) {
	                var timeNow = new Date(data.timeNow);
	                $('.cdtime').each(function () {
	                    var self = $(this);
	                    var endTime = self.attr('endTime');
	                    var duringSecond = (endTime - timeNow.getTime()) / 1000;
	                    self.attr('secondcount', parseInt(duringSecond));
	                });
	                ticker.init({
	                    "step": step,
	                    "timer": timer
	                });
	            });
	        },
	
	        //定金支付倒计时
	        presaleSecondCount: function presaleSecondCount(options) {
	            //默认参数
	            var defaults = {
	                timer: 1000,
	                step: 1
	            };
	            var settings = $.extend(defaults, options || {});
	
	            //timer: 设置倒计时定时器时间，默认1000ms
	            var step = settings.step || 1;
	            var timer = settings.timer || 1000;
	            var that = this;
	            that.ajaxGetTime(null, function (data) {
	                var timeNow = new Date(data.timeNow);
	                $('.payTime em').each(function () {
	                    var self = $(this);
	                    var orderTime = self.attr('order_time');
	                    var endTime = self.attr('presaleendtime');
	                    var payTime = 30 * 60 * 1000;
	                    //var duringSecond;
	                    // if(endTime > timeNow.getTime()){
	                    //     if(endTime <= (parseInt(orderTime) + parseInt(payTime))){
	                    //         duringSecond = (endTime - timeNow.getTime()) / 1000;
	                    //     }else{
	                    //         duringSecond = (30*60*1000 - (timeNow.getTime() - orderTime)) / 1000;
	                    //     }
	                    // }else{
	                    //     return
	                    // }
	                    var duringSecond = (30 * 60 * 1000 - (timeNow.getTime() - orderTime)) / 1000;
	                    self.attr('secondcount', parseInt(duringSecond));
	                });
	                ticker.init({
	                    "step": step,
	                    "timer": timer
	                });
	            });
	        },
	
	        //尾款支付倒计时
	        presaleSecondCountLast: function presaleSecondCountLast(options) {
	            //默认参数
	            var defaults = {
	                timer: 1000,
	                step: 1
	            };
	            var settings = $.extend(defaults, options || {});
	
	            //timer: 设置倒计时定时器时间，默认1000ms
	            var step = settings.step || 1;
	            var timer = settings.timer || 1000;
	            var that = this;
	            that.ajaxGetTime(null, function (data) {
	                var timeNow = new Date(data.timeNow);
	                $('.goodpay-step-two-btn .hideTime').each(function () {
	                    var self = $(this);
	                    var orderEndTime = self.attr('order_end_time');
	                    var duringSecond = (orderEndTime - timeNow.getTime()) / 1000;
	                    self.attr('secondcount', parseInt(duringSecond));
	                });
	                ticker.init({
	                    "step": step,
	                    "timer": timer
	                });
	            });
	            ticker.init({
	                "step": step,
	                "timer": timer
	            });
	        },
	
	        //订单详情页付定金/全款倒计时
	        presaleConSecondCount: function presaleConSecondCount(options) {
	            //默认参数
	            var defaults = {
	                timer: 1000,
	                step: 1
	            };
	            var settings = $.extend(defaults, options || {});
	
	            //timer: 设置倒计时定时器时间，默认1000ms
	            var step = settings.step || 1;
	            var timer = settings.timer || 1000;
	            var that = this;
	            that.ajaxGetTime(null, function (data) {
	                var timeNow = new Date(data.timeNow);
	                $('.cdtime').each(function () {
	                    var self = $(this);
	                    var orderTime = self.attr('endtime');
	                    var duringSecond = (30 * 60 * 1000 - (timeNow.getTime() - orderTime)) / 1000;
	                    self.attr('secondcount', parseInt(duringSecond));
	                });
	                ticker.init({
	                    "step": step,
	                    "timer": timer
	                });
	            });
	        },
	
	        //订单详情页付尾款倒计时
	        presaleConSecondCountDj: function presaleConSecondCountDj(options) {
	            //默认参数
	            var defaults = {
	                timer: 1000,
	                step: 1
	            };
	            var settings = $.extend(defaults, options || {});
	
	            //timer: 设置倒计时定时器时间，默认1000ms
	            var step = settings.step || 1;
	            var timer = settings.timer || 1000;
	            var that = this;
	            that.ajaxGetTime(null, function (data) {
	                var timeNow = new Date(data.timeNow);
	                $('.cdtime').each(function () {
	                    var self = $(this);
	                    var orderTime = self.attr('endtime');
	                    var duringSecond = (orderTime - timeNow.getTime()) / 1000;
	                    self.attr('secondcount', parseInt(duringSecond));
	                });
	                ticker.init({
	                    "step": step,
	                    "timer": timer
	                });
	            });
	        }
	
	    };
	    module.exports = timeModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Ticker = {
	        init: function init(options) {
	            //默认参数
	            var defaults = {
	                timer: 1000,
	                step: 1
	            };
	            var settings = $.extend(defaults, options || {});
	
	            var _this = this;
	
	            this.selector = "secondcount";
	            this.RED_TICKER_PASSED = 0;
	            this.RED_TICKER_ITEMS = [];
	            this.RED_TICKER_ITEMS_ON_ACTIVE = [];
	
	            _this.adapt();
	            _this.render();
	
	            _this.RED_TICKER_INTERVAL = window.setInterval(function () {
	                _this.tick(settings.step);
	            }, settings.timer);
	        },
	        tick: function tick(step) {
	            var _this = this;
	            _this.RED_TICKER_PASSED = _this.RED_TICKER_PASSED + step;
	            for (var i = 0; i < _this.RED_TICKER_ITEMS_ON_ACTIVE.length; i++) {
	                var item = _this.RED_TICKER_ITEMS_ON_ACTIVE[i];
	                _this._render(item);
	            }
	        },
	        adapt: function adapt() {
	            var _this = this;
	            var a = $("[" + _this.selector + "]");
	            a.each(function (n, i) {
	
	                if ($.inArray(i, _this.RED_TICKER_ITEMS)) {
	                    i.renderFn = _this.renderFn;
	                    i.rendAble = 0;
	                    i.secondcount = window.parseInt($(i).attr("secondcount"));
	                    _this.RED_TICKER_ITEMS.push(i);
	                    _this._render(i);
	                }
	            });
	        },
	        _render: function _render(item) {
	            var _this = this;
	            var secondcountRemain = item.secondcount - _this.RED_TICKER_PASSED;
	
	            item.renderFn(_this.parseData(secondcountRemain));
	        },
	        render: function render() {
	            var _this = this;
	            _this.RED_TICKER_ITEMS_ON_ACTIVE = [];
	
	            for (var i = 0; i < _this.RED_TICKER_ITEMS.length; i++) {
	                var item = _this.RED_TICKER_ITEMS[i];
	                // if (_this.inScreen(item)) {
	                _this.RED_TICKER_ITEMS_ON_ACTIVE.push(item);
	                // }
	            }
	        },
	        inScreen: function inScreen(dom) {
	            var p = $(dom).offset();
	            var result = 0;
	            var cHeight = $(window).height();
	            //var aHeight=$(document).height();
	            var scrollTop = $(window).scrollTop();
	            if (p.top > scrollTop && p.top <= scrollTop + cHeight) {
	                result = 1;
	            }
	            return result;
	        },
	        parseData: function parseData(secondcount) {
	            var daySecond = 60 * 60 * 24;
	            var hourSecond = 60 * 60;
	            var result = {};
	            result.secondcount = secondcount;
	            result.day = parseInt(secondcount / daySecond);
	            result.hour = parseInt(secondcount % daySecond / hourSecond);
	            result.minute = parseInt(secondcount % hourSecond / 60);
	            result.second = parseInt(secondcount % 60 / 1);
	            return result;
	        },
	        renderFn: function renderFn(d) {
	            var _this = this;
	            var num = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
	
	            var renderDefault = function renderDefault(data) {
	                if (data.secondcount < 0) {
	                    return;
	                }
	                if ($(_this).hasClass("special")) {
	                    if (data.day == 0) {
	                        _this.innerHTML = "<b>" + format(data.hour) + "</b>" + '时' + "<b>" + format(data.minute) + "</b>" + '分' + "<b>" + format(data.second) + "</b>" + '秒';
	                    } else {
	                        _this.innerHTML = "<b>" + format(data.day) + "</b>" + '天' + "<b>" + format(data.hour) + "</b>" + '时' + "<b>" + format(data.minute) + "</b>" + '分' + "<b>" + format(data.second) + "</b>" + '秒';
	                    }
	                } else {
	                    _this.innerHTML = '<div class="bg hour">' + format(data.hour) + '</div>' + '<div class="semicolon">:</div>' + '<div class="bg minute">' + format(data.minute) + '</div>' + '<div class="semicolon">:</div>' + '<div class="bg second">' + format(data.second) + '</div>';
	                }
	            };
	
	            var renderCustom = function renderCustom(data) {
	                _this.innerHTML = "" + format(data.day) + " d" + format(data.hour) + "h" + format(data.minute) + "m" + format(data.second) + "s";
	            };
	
	            var renderCustom_myGw = function renderCustom_myGw(data) {
	                if (data.hour < 0) {
	                    data.hour = 0;
	                }
	                if (data.minute < 0) {
	                    data.minute = 0;
	                }
	                if (data.hour < 0 && data.minute < 0) {
	                    _this.innerHTML = "";
	                } else {
	                    _this.innerHTML = "仅剩" + format(data.hour) + "小时" + format(data.minute) + "分";
	                }
	            };
	
	            var renderCustom_myGw_delay = function renderCustom_myGw_delay(data) {
	                if (data.day < 0) {
	                    data.day = 0;
	                }
	                if (data.hour < 0) {
	                    data.hour = 0;
	                }
	                if (data.minute < 0) {
	                    data.minute = 0;
	                }
	                _this.innerHTML = "剩余&nbsp;" + format(data.day) + "天" + format(data.hour) + "小时";
	            };
	
	            var myGwDetail_delay = function myGwDetail_delay(data) {
	                if (data.day < 0) {
	                    data.day = 0;
	                }
	                if (data.hour < 0) {
	                    data.hour = 0;
	                }
	                if (data.minute < 0) {
	                    data.minute = 0;
	                }
	                if (data.day < 0 && data.hour < 0 && data.minute < 0) {
	                    _this.innerHTML = "";
	                } else {
	                    _this.innerHTML = "剩余&nbsp;" + format(data.day) + "天" + format(data.hour) + "时" + format(data.minute) + "分";
	                }
	            };
	
	            var myGwDetail_delay_1 = function myGwDetail_delay_1(data) {
	                if (data.day < 0) {
	                    data.day = 0;
	                }
	                if (data.hour < 0) {
	                    data.hour = 0;
	                }
	                if (data.minute < 0) {
	                    data.minute = 0;
	                }
	                if (data.day < 0 && data.hour < 0 && data.minute < 0) {
	                    _this.innerHTML = "";
	                } else {
	                    _this.innerHTML = format(data.day) + "天" + format(data.hour) + "时" + format(data.minute) + "分";
	                }
	            };
	
	            var renderCustom_myGwDetail = function renderCustom_myGwDetail(data) {
	                if (data.hour < 0) {
	                    data.hour = 0;
	                }
	                if (data.minute < 0) {
	                    data.minute = 0;
	                }
	                if (data.hour < 0 && data.minute < 0) {
	                    _this.innerHTML = "";
	                } else {
	                    _this.innerHTML = format(data.hour) + "小时" + format(data.minute) + "分";
	                }
	            };
	
	            var renderCustom_temai = function renderCustom_temai(data) {
	                if (data.hour < 0) {
	                    data.hour = 0;
	                }
	                if (data.minute < 0) {
	                    data.minute = 0;
	                }
	                if (data.second < 0) {
	                    data.second = 0;
	                }
	                _this.innerHTML = format(data.hour) + "小时" + format(data.minute) + "分" + format(data.second) + "秒后结束";
	            };
	
	            var format = function format(number) {
	                var _this = this;
	                if (!$.inArray(number, num)) {
	                    return "0" + number;
	                } else {
	                    return number;
	                }
	            };
	
	            switch ($(_this).attr("render_type")) {
	                case "Custom":
	                    renderCustom(d);
	                    break;
	                case "myGw":
	                    renderCustom_myGw(d);
	                    break;
	                case "myGwDetail":
	                    renderCustom_myGwDetail(d);
	                    break;
	                case "temai":
	                    renderCustom_temai(d);
	                    break;
	                case "myGw_delay":
	                    renderCustom_myGw_delay(d);
	                    break;
	                case "myGw_detailDelay":
	                    myGwDetail_delay(d);
	                    break;
	                case "myGw_detailDelay_1":
	                    myGwDetail_delay_1(d);
	                    break;
	                default:
	                    renderDefault(d);
	                    break;
	            }
	        }
	    };
	    module.exports = Ticker;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tplModel = {
	        render: function render(data, tpl) {
	            var render = template.compile(tpl.tpl);
	            return render(data);
	        }
	    };
	    module.exports = tplModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
		var lazyload = __webpack_require__(2);
	
		exports.slideBox = function (opt) {
			//默认参数
			var defaults = {
				backgroundImg: false,
				directBtn: false,
				direction: 'fadein',
				duration: 0.6, //unit:seconds
				easing: 'swing', //swing,linear
				delay: 3, //unit:seconds
				startIndex: 0,
				width: 820,
				height: 360,
				id: null,
				isLazyLoad: true
			};
			var settings = $.extend(defaults, opt || {});
			if (settings.data.length == 0) {
				return false;
			}
	
			var wrapper = $("#" + settings.id);
			var ulWrapper = $('<div class="ulwp"></div>');
			if (wrapper.length == 0) {
				return false;
			}
			function render() {
				var items = settings.data;
				if (settings.backgroundImg) {
					var bg_id = wrapper.attr("id") + "Bg";
					var bg_div = $('<div class="background" id="' + bg_id + '"></div>');
				}
	
				if (settings.directBtn) {
					var directBtn = $('<a href="javascript:;" class="leftBtn"></a><a href="javascript:;" class="rightBtn"></a>');
					ulWrapper.append(directBtn);
				}
	
				var ul = $('<ul class="items"></ul>');
	
				$(items).each(function (index, item) {
					var imgUrl = item.imgUrl;
					var bgImgUrl_1 = item.bgImgUrl_1;
					var bgImgUrl_2 = item.bgImgUrl_2;
					var bgTextUrl_1 = item.bgTextUrl_1;
					var bgTextUrl_2 = item.bgTextUrl_2;
					var textUrl = item.textUrl;
					var bgColor = item.bgColor;
					var controlText = item.controlText;
					var clstag = item.clstag;
	
					var li = null;
					if (bgColor != "") {
						if (settings.isLazyLoad) {
							if (controlText != "") {
								li = '<li controlText="' + controlText + '" bgColor="' + bgColor + '"><a href="' + textUrl + '" clstag="' + clstag + '" target="_blank"><img data-original="' + imgUrl + '" src="" class="lazy"></a></li>';
							} else {
								li = '<li bgColor="' + bgColor + '"><a href="' + textUrl + '" clstag="' + clstag + '" target="_blank"><img data-original="' + imgUrl + '" src="" class="lazy"></a></li>';
							}
						} else {
							if (controlText != "") {
								li = '<li controlText="' + controlText + '" bgColor="' + bgColor + '"><a href="' + textUrl + '" clstag="' + clstag + '" target="_blank"><img src="' + imgUrl + '"></a></li>';
							} else {
								li = '<li bgColor="' + bgColor + '"><a href="' + textUrl + '" clstag="' + clstag + '" target="_blank"><img src="' + imgUrl + '"></a></li>';
							}
						}
					} else {
						if (settings.isLazyLoad) {
							if (controlText != "") {
								li = '<li controlText="' + controlText + '"><a href="' + textUrl + '" clstag="' + clstag + '" target="_blank"><img data-original="' + imgUrl + '" src="" class="lazy"></a></li>';
							} else {
								li = '<li><a href="' + textUrl + '" clstag="' + clstag + '" target="_blank"><img data-original="' + imgUrl + '" src="" class="lazy"></a></li>';
							}
						} else {
							if (controlText != "") {
								li = '<li controlText="' + controlText + '"><a href="' + textUrl + '" clstag="' + clstag + '" target="_blank"><img src="' + imgUrl + '"></a></li>';
							} else {
								li = '<li><a href="' + textUrl + '" clstag="' + clstag + '" target="_blank"><img src="' + imgUrl + '"></a></li>';
							}
						}
					}
	
					ul.append(li);
	
					var bg_img = null;
					if (index == 0) {
						if (settings.isLazyLoad) {
							bg_wp = '<div class="bg-wapper curr">' + '<a href="' + bgTextUrl_1 + '" clstag="' + clstag + '-1" target="_blank"><img data-original="' + bgImgUrl_1 + '" src="" class="lazy"/></a>' + '<a href="' + bgTextUrl_2 + '" clstag="' + clstag + '-2" target="_blank"><img data-original="' + bgImgUrl_2 + '" src="" class="lazy"/></a>' + '</div>';
						} else {
							bg_wp = '<div class="bg-wapper curr">' + '<a href="' + bgTextUrl_1 + '" clstag="' + clstag + '-1" target="_blank"><img src="' + bgImgUrl_1 + '"/></a>' + '<a href="' + bgTextUrl_2 + '" clstag="' + clstag + '-2" target="_blank"><img src="' + bgImgUrl_2 + '"/></a>' + '</div>';
						}
					} else {
						if (settings.isLazyLoad) {
							bg_wp = '<div class="bg-wapper">' + '<a href="' + bgTextUrl_1 + '" clstag="' + clstag + '-1" target="_blank"><img data-original="' + bgImgUrl_1 + '" src="" class="lazy"/></a>' + '<a href="' + bgTextUrl_2 + '" clstag="' + clstag + '-2" target="_blank"><img data-original="' + bgImgUrl_2 + '" src="" class="lazy"/></a>' + '</div>';
						} else {
							bg_wp = '<div class="bg-wapper">' + '<a href="' + bgTextUrl_1 + '" clstag="' + clstag + '-1" target="_blank"><img src="' + bgImgUrl_1 + '"/></a>' + '<a href="' + bgTextUrl_2 + '" clstag="' + clstag + '-2" target="_blank"><img src="' + bgImgUrl_2 + '"/></a>' + '</div>';
						}
					}
	
					if (settings.backgroundImg) {
						bg_div.append(bg_wp);
					}
				});
	
				ulWrapper.append(ul);
				wrapper.append(ulWrapper);
				if (settings.backgroundImg) {
					wrapper.append(bg_div);
				}
			};
			render();
			// lazyload.fn.init();
			//计算相关数据
			var ul = wrapper.find(".ulwp").children('ul.items'),
			    lis = ul.find('li'),
			    firstPic = lis.first().find('img');
			var li_num = lis.size(),
			    li_height = 0,
			    li_width = 0;
			//定义滚动顺序:ASC/DESC
			var order_by = 'ASC';
			//初始化
			function init() {
				if (!wrapper.size()) return false;
				//手动设定值优先
				li_height = settings.height ? settings.height : lis.first().height();
				li_width = settings.width ? settings.width : lis.first().width();
	
				wrapper.css({ width: li_width + 'px', height: li_height + 'px' });
				lis.css({ /*width: li_width+'px',*/height: li_height + 'px' });
	
				ul.find('li').eq(settings.startIndex).addClass('active');
				if (lis.length != 1) {
					var tips = $('<div class="tips"></div>').appendTo(ulWrapper);
					var nums = $('<div class="nums"></div>').hide().appendTo(tips);
	
					lis.each(function (i, n) {
						var a = $(n).find('a'),
						    css = '';
						i == settings.startIndex && (css = 'active');
						var txt = $(n).attr("controlText") || "";
	
						$('<a><div>' + txt + '</div></a>').addClass(css).mouseover(function () {
							var self = $(this);
							var thisLi = ul.find('li:eq(' + self.index() + ')');
							self.addClass('active').siblings().removeClass('active');
							thisLi.addClass('active').siblings().removeClass('active');
							var bgColor = thisLi.attr("bgColor") || "";
	
							if (bgColor != "") {
								wrapper.parent().css("background-color", bgColor);
								wrapper.parent().find(".slide").css("background-color", bgColor);
							}
							start();
							stop();
						}).appendTo(nums);
					});
					nums.show();
	
					wrapper.find(".rightBtn").bind("click", function () {
						start();
						stop();
					});
	
					wrapper.find(".leftBtn").bind("click", function () {
						var thisTip = wrapper.find(".nums .active");
						var thisLi = null;
						if (thisTip.prev().size()) {
							thisTip.prev().addClass("active").siblings().removeClass("active");
							thisLi = ul.find('li:eq(' + (thisTip.index() - 1) + ')');
						} else {
							var n = thisTip.parent().children().length - 1;
							thisTip.parent().children().eq(n).addClass("active").siblings().removeClass("active");
							thisLi = ul.find('li:eq(' + n + ')');
						}
	
						thisLi.addClass('active').siblings().removeClass('active');
						var bgColor = thisLi.attr("bgColor");
	
						if (bgColor != "") {
							wrapper.parent().css("background-color", bgColor);
							wrapper.parent().find(".slide").css("background-color", bgColor);
						}
	
						start();
						stop();
					});
				}
	
				lis.size() >= 1 && start();
			}
			//开始轮播
			function start() {
				var active = ul.find('li.active'),
				    active_a = active.find('a');
				var index = active.index();
				if (settings.direction == 'fadein') {
					param = {};
					ul.find("li").each(function (i, item) {
						if (i != index) {
							$(item).fadeOut(300);
						}
					});
					ul.find("li").each(function (i, item) {
						if (i == index) {
							$(item).fadeIn(300);
						}
					});
				}
				wrapper.find('.nums').find('a:eq(' + index + ')').addClass('active').siblings().removeClass('active');
	
				var bgColor = active.attr("bgColor");
	
				if (bgColor != "") {
					wrapper.parent().css("background-color", bgColor);
					wrapper.parent().find(".slide").css("background-color", bgColor);
				}
	
				if (settings.backgroundImg) {
					var id = wrapper.attr("id");
					var bgId = id + "Bg";
					$("#" + bgId).find(".bg-wapper").each(function (num, item) {
						if (num === index) {
							$(item).addClass("curr");
							$(item).fadeIn(0);
						} else {
							$(item).removeClass("curr");
							$(item).fadeOut(0);
						}
					});
				}
	
				ul.stop().animate(param, settings.duration * 1000, settings.easing, function () {
					active.removeClass('active');
					if (order_by == 'ASC') {
						if (active.next().size()) {
							active.next().addClass('active');
						} else {
							active.parent().children().eq(0).addClass('active');
						}
					} else if (order_by == 'DESC') {
						if (active.prev().size()) {
							active.prev().addClass('active');
						} else {
							order_by = 'ASC';
							var num = active.parent().children().length - 1;
							active.parent().children().eq(num).addClass('active');
						}
					}
				});
				wrapper.data('timeid', window.setTimeout(start, settings.delay * 1000));
			};
			//停止轮播
			function stop() {
				window.clearTimeout(wrapper.data('timeid'));
			};
	
			wrapper.on("mouseenter", function (e) {
				stop();
			}).on("mouseleave", function (e) {
				wrapper.data('timeid', window.setTimeout(start, settings.delay * 1000));
			});
	
			//首张图片加载完毕后执行初始化
			var imgLoader = new Image();
			imgLoader.onload = null;
			init();
			imgLoader.src = firstPic.attr('src');
		};
	
		exports.getImgData = function (className) {
			var slideData = {};
			slideData["data"] = [];
			$('input.' + className).each(function (index) {
				slideData["data"].push({
					"textUrl": $(this).attr("textUrl") || "",
					"imgUrl": $(this).attr("imgUrl") || "",
					"bgImgUrl_1": $(this).attr("bgImgUrl_1") || "",
					"bgImgUrl_2": $(this).attr("bgImgUrl_2") || "",
					"bgTextUrl_1": $(this).attr("bgTextUrl_1") || "",
					"bgTextUrl_2": $(this).attr("bgTextUrl_2") || "",
					"bgColor": $(this).attr("bgColor") || "",
					"controlText": $(this).attr("controlText") || "",
					"clstag": $(this).attr("clstag") || ""
				});
			}).remove();
			return slideData.data;
		};
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var goTop = function goTop(options) {
	        var defaults = {
	            midWidth: 1210
	        };
	        var settings = $.extend(defaults, options || {});
	
	        var init = function init() {
	            //解决IE7下影响footer的margin-top失效问题
	            $("#go-top").after("<div></div>");
	            setLocation();
	            setVisible();
	            handleResize();
	            highlight();
	            handleScroll();
	        };
	        var handleResize = function handleResize() {
	            $(window).resize(function () {
	                adaptWidth();
	                setLocation();
	            });
	        };
	        var handleScroll = function handleScroll() {
	            $(window).scroll(function () {
	                setVisible();
	            });
	            $(".go-top a").bind("click", function () {
	                $(".go-top").addClass("clk");
	                if ($(this).hasClass("j-go-top")) {
	                    $("html,body").animate({ scrollTop: 0 });
	                    $(this).siblings().removeClass("hover");
	                } else {
	                    var dataIdx = $(this).attr("data-index");
	                    var scrollTop = $("div[data-idx='" + dataIdx + "']").offset().top;
	                    $("html,body").animate({ scrollTop: scrollTop });
	                    $(this).addClass("hover").siblings().removeClass("hover");
	                }
	                setTimeout(function () {
	                    $(".go-top").removeClass("clk");
	                }, 500);
	            });
	        };
	        var setLocation = function setLocation() {
	            var winWidth = $(window).width();
	            var midWidth = settings.midWidth;
	            $("#go-top").css("right", (winWidth - midWidth) / 2 - 62 - 20);
	        };
	        var setVisible = function setVisible() {
	            if (!adaptWidth()) {
	                return false;
	            }
	
	            if ($(this).scrollTop() > 215) {
	                $("#go-top").css("display", "block");
	            } else {
	                $("#go-top").css("display", "none");
	            }
	        };
	        var highlight = function highlight() {
	            $(window).scroll(function () {
	                if ($(".go-top").hasClass("clk")) {
	                    return false;
	                }
	                $("[data-idx]").each(function () {
	                    var scrollTop = $(document).scrollTop();
	                    var offsetTop = $(this).offset().top;
	
	                    var offset = offsetTop - scrollTop;
	
	                    if (offset < 200 && offset > 0) {
	                        var dataIdx = $(this).attr("data-idx");
	                        $("a[data-index='" + dataIdx + "']").addClass("hover").siblings().removeClass("hover");
	                        return false;
	                    }
	                });
	            });
	        };
	        var adaptWidth = function adaptWidth() {
	            if ($(window).width() < 1350) {
	                $(".go-top").css("display", "none");
	                return false;
	            } else {
	                $(".go-top").css("display", "block");
	                return true;
	            }
	        };
	        init();
	    };
	    exports.goTop = goTop;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	/**
	 * Created by chenjia on 2016/9/23.
	 *
	 * update by liuwenbin16 on 2019/02/24 for 新人价
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var priceModel = __webpack_require__(11);
	    var storeSelector = __webpack_require__(49);
	
	    var priceV2 = {
	        skuArry: [],
	        pageNum: 40,
	        pin: "",
	        /**
	         * @param root: 根节点选择器，如 .floor #slide
	         */
	        init: function init(root) {
	            var self = this;
	            if ($("#priceQuerySwitch").val() != "OFF") {
	                self.skuArry = [];
	                self.pin = storeSelector.getCookie("pin");
	                self.getPrice(root);
	            }
	        },
	        getPrice: function getPrice(root) {
	            var self = this;
	
	            var skuList = "";
	
	            var skuObj;
	            if (root) {
	                skuObj = $(root).find("[skuid]");
	            } else {
	                skuObj = $("[skuid]");
	            }
	
	            skuObj.each(function () {
	                if ($(this).attr("hasPrice") !== "1") {
	                    if ($(this).attr("skuid").indexOf("J_") < 0) {
	                        skuList = skuList + "," + "J_" + $(this).attr("skuid");
	                    } else {
	                        skuList = skuList + "," + $(this).attr("skuid");
	                    }
	                }
	            });
	
	            skuList = skuList.substring(1, skuList.length);
	            skuList = skuList.split(",");
	
	            var num = Math.ceil(skuList.length / self.pageNum);
	
	            for (var i = 1; i <= num; i++) {
	                var skuids = "";
	                for (var j = (i - 1) * self.pageNum; j < i * self.pageNum; j++) {
	                    if (typeof skuList[j] != "undefined") {
	                        skuids = skuids + "," + skuList[j];
	                    }
	                }
	                skuids = skuids.substring(1, skuids.length);
	
	                if (skuids != "") {
	                    self.skuArry.push(skuids);
	                }
	            }
	
	            if (self.skuArry.length == 0) {
	                return false;
	            }
	            for (var i = 0; i < self.skuArry.length; i++) {
	                self.ajaxPrice(self.skuArry[i], self.pin);
	            }
	        },
	        ajaxPrice: function ajaxPrice(skuArry, pin) {
	            var self = this;
	            var arg = { "skuids": skuArry, "pin": pin, "ext": "00001000", "source": "jdglobal" };
	
	            priceModel.ajaxGetPrice(arg, function (data) {
	
	                $.each(data, function () {
	                    var newPrice = priceModel.formatPrice(this.p);
	                    var oldPrice = priceModel.formatPrice(this.m);
	
	                    var samPrice = null;
	                    var plusPrice = null;
	                    var newMemberPrice = null;
	                    if (this.nup) {
	                        newMemberPrice = priceModel.formatPrice(this.nup); //新人价
	                    }
	                    if (this.sp) {
	                        samPrice = priceModel.formatPrice(this.sp); //山姆价
	                    }
	                    if (this.tpp) {
	                        plusPrice = priceModel.formatPrice(this.tpp); //plus价
	                    }
	
	                    var thisObj = $("[skuid='" + this.id + "']");
	
	                    if (newPrice == "-1" || oldPrice == "-1") {
	                        thisObj.find(".discount").remove();
	                        return true;
	                    };
	
	                    //有颜色无套装（item-style-v3）时，价格跟随鼠标变化，plus/sams价格同时变化
	                    if ($('#plist').hasClass('item-style-v3')) {
	                        //判断价格为哪一个价格，以及是否展示plus/sams价格
	                        var showVipPrice = function showVipPrice(ele) {
	                            var tppPlusPrice = null;
	                            var spSamsPrice = null;
	                            var nupNewMemberPrice = null;
	                            ele.each(function () {
	                                if ($(this).attr('psitemsku') && $(this).attr('psitemsku') == _this.id) {
	                                    var vipPrice = $(this).siblings('.sam');
	                                    $(this).html("<b>&yen;</b>" + priceModel.formatPrice(_this.p));
	
	                                    if (_this.tpp) {
	                                        tppPlusPrice = priceModel.formatPrice(_this.tpp);
	                                    }
	                                    if (_this.sp) {
	                                        spSamsPrice = priceModel.formatPrice(_this.sp);
	                                    }
	                                    if (_this.nup) {
	                                        nupNewMemberPrice = priceModel.formatPrice(_this.nup);
	                                    }
	                                    if (tppPlusPrice != null) {
	                                        vipPrice.html("\n                                            <div class=\"p-plus\">&yen;" + tppPlusPrice + "</div>\n                                            <i class=\"logo-plus\"></i>\n                                        ");
	                                    } else if (spSamsPrice !== null) {
	                                        vipPrice.html("\n                                            <div class=\"p-sam\">&yen;" + spSamsPrice + "</div>\n                                            <i class=\"logo-sams\"></i>\n                                        ");
	                                    } else if (nupNewMemberPrice !== null) {
	                                        vipPrice.html("\n                                            <div class=\"p-nup\">&yen;" + nupNewMemberPrice + "</div>\n                                            <i class=\"logo-nup\"></i>\n                                        ");
	                                    } else {
	                                        vipPrice.html('');
	                                    }
	                                }
	                            });
	                        };
	                        //无套装无颜色（item-style-v4）、有套装无颜色（item-style-v1）时价格和plus/sams价格展示
	
	
	                        var _this = this;
	                        showVipPrice($('.item .price span'));
	                        $(".p-scroll .ps-item").hover(function () {
	                            if ($(this).hasClass('curr')) {
	                                var psItemSku = $(this).attr('skuid');
	                                $(this).parents(".item").find('.price span').attr('psItemSku', psItemSku);
	                            }
	                            showVipPrice($(this).parents('.item').find(".price span"));
	                        });
	                    } else {
	                        thisObj.find(".price span").each(function () {
	                            if ($(this).parents("[status]").attr("status") == "1") {
	                                // 首页特卖楼层，如果status为0，表示非预告，请求实时价格；为1，表示预告，则使用配置的价格，只更新del中的价格
	                            } else {
	                                $(this).html("<b>&yen;</b>" + newPrice);
	                            }
	                        });
	
	                        thisObj.parents('.gl-item').find(".price span").each(function () {
	                            var samDiv = $(this).parent().find(".sam");
	                            if (samDiv.length > 0) {
	                                if (plusPrice != null) {
	                                    samDiv.html("\n                                        <div class=\"p-plus\">&yen;" + plusPrice + "</div>\n                                        <i class=\"logo-plus\"></i>\n                                    ");
	                                } else if (samPrice !== null) {
	                                    samDiv.html("\n                                        <div class=\"p-sam\">&yen;" + samPrice + "</div>\n                                        <i class=\"logo-sams\"></i>\n                                    ");
	                                } else if (newMemberPrice !== null) {
	                                    samDiv.html("\n                                        <div class=\"p-nup\">&yen;" + newMemberPrice + "</div>\n                                        <i class=\"logo-nup\"></i>\n                                    ");
	                                }
	                            }
	                        });
	                    }
	
	                    thisObj.find(".price del").html("&yen;" + oldPrice);
	                    thisObj.find(".price .consult").html("参考价&yen;<em>" + oldPrice + "</em>");
	
	                    thisObj.attr("hasPrice", "1");
	
	                    var discount = priceModel.getDiscount(newPrice, oldPrice);
	
	                    if (discount == "") {
	                        thisObj.find(".discount").remove();
	                    } else {
	                        if (thisObj.parents(".w").parent().hasClass("special-sale")) {
	                            thisObj.find(".discount").html('<div class="bg"><div class="poi"><span class="num">' + discount + '</span><span>折</span></div></div>');
	                        } else {
	                            thisObj.find(".discount").html(discount + "折");
	                        }
	                    }
	                });
	            });
	        }
	    };
	    module.exports = priceV2;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var ipLocArray = {
	        "province": "",
	        "city": "",
	        "area": ""
	    };
	    var selector = {
	        stateObj: {},
	        init: function init() {
	            var self = this;
	
	            self.loadStore();
	            self.addEvent();
	        },
	        loadStore: function loadStore() {
	            var self = this;
	            ipLocArray = this.getIpLoc() || {
	                "province": "1",
	                "city": "72",
	                "area": "4137"
	            };
	
	            var tag1 = null;
	            var proviceId = "";
	            var proviceName = "";
	            var firstTabPanel = $('#store-selector div.mc[data-area="0"] ul');
	            for (id in iplocation) {
	                name = iplocation[id]["name"];
	                if (name.length <= 4) {
	                    firstTabPanel.append("<li><a data-value='" + id + "' href='#none' class='selectProvince'>" + name + "</a></li>");
	                } else {
	                    firstTabPanel.append("<li class='long-area'><a data-value='" + id + "' class='selectProvince' href='#none'>" + name + "</a></li>");
	                }
	
	                if (id === ipLocArray.province && tag1 == null) {
	                    tag1 = "1";
	                    proviceName = name;
	                    proviceId = id;
	                    $("#store-selector div.mt li").eq(0).find("em").text(name);
	                }
	            }
	
	            var cityId = "";
	            var cityName = "";
	
	            for (i in provinceCityJson[ipLocArray.province]) {
	                var cityName = provinceCityJson[ipLocArray.province][i]["name"];
	                cityId = provinceCityJson[ipLocArray.province][i]["id"] + "";
	                if (cityId === ipLocArray.city) {
	                    $("#store-selector div.mt li").eq(1).find("em").text(cityName);
	                    break;
	                }
	            }
	            $('#store-selector [data-area="0"]').addClass("hide");
	
	            self.stateObj.proviceName = proviceName;
	            self.stateObj.cityName = cityName;
	
	            self.setCity(proviceId, proviceName);
	            self.setArea(cityId, cityName, true);
	        },
	
	        //获取ip地址对应数值
	        getIpLoc: function getIpLoc() {
	            var self = this;
	            try {
	                var ipLoc = self.getCookie("ipLoc-djd");
	
	                var province = "1";
	                var city = "72";
	                var area = "4137";
	                var firstTabPanel = $('#store-selector div.mc[data-area="0"] ul');
	                if (ipLoc) {
	                    var ipArray = ipLoc.split("-");
	                    province = ipArray[0];
	                    city = ipArray[1];
	                    area = ipArray[2];
	                }
	
	                var ipLocObj = {
	                    "province": province,
	                    "city": city,
	                    "area": area
	                };
	                return ipLocObj;
	            } catch (error) {
	                return null;
	            }
	        },
	        addEvent: function addEvent() {
	            var self = this;
	
	            var timeout;
	            $("#store-selector").hover(function () {
	                var _this = this;
	
	                timeout = setTimeout(function () {
	                    $(_this).addClass("hover");
	                }, 400);
	            }, function () {
	                clearTimeout(timeout);
	                $(this).removeClass("hover");
	            });
	
	            $("#store-selector div.mt li").on("click", function () {
	                var dataIdx = $(this).attr("data-idx");
	
	                if (dataIdx == "0") {
	                    $("#store-selector div.mt li").eq(0).find("em").text("请选择");
	                    $("#store-selector div.mt li").eq(1).addClass("hide").find("em").text("请选择");
	                    $("#store-selector div.mt li").eq(2).addClass("hide").find("em").text("请选择");
	                    $(this).addClass("curr");
	                    $('#store-selector [data-area="0"]').removeClass("hide");
	                    $('#store-selector [data-area="1"]').addClass("hide");
	                    $('#store-selector [data-area="2"]').addClass("hide");
	                } else if (dataIdx == "1") {
	                    $("#store-selector div.mt li").eq(0).removeClass("curr");
	                    $("#store-selector div.mt li").eq(1).addClass("curr").find("em").text("请选择");
	                    $("#store-selector div.mt li").eq(2).addClass("hide").find("em").text("请选择");
	                    $('#store-selector [data-area="1"]').removeClass("hide");
	                    $('#store-selector [data-area="2"]').addClass("hide");
	                }
	            });
	
	            $(".JD-stock .mc").delegate(".selectProvince", "click", function () {
	                var id = $(this).attr("data-value");
	                var name = $(this).text();
	                self.setCity(id, name);
	            });
	
	            $(".JD-stock .mc").delegate(".selectCity", "click", function () {
	                var name = $(this).text();
	                var id = $(this).attr("data-value");
	
	                self.setArea(id, name);
	            });
	
	            $(".JD-stock .mc").delegate(".selectArea", "click", function () {
	                var id = $(this).attr("data-value");
	                var name = $(this).text();
	                ipLocArray.area = id;
	                var iplocStr = ipLocArray.province + "-" + ipLocArray.city + "-" + ipLocArray.area + "-" + "0-";
	
	                var day = 30;
	                var date = new Date();
	                date.setTime(date.getTime() + 24 * day * 60 * 60 * 1000);
	                document.cookie = "ipLoc-djd" + "=" + escape(iplocStr) + ";expires=" + date.toGMTString() + ";path=/;domain=." + pageConfig.FN_getDomain();
	
	                // location.reload();
	                location.href = location.href.replace(/#none/g, "");
	            });
	        },
	        setCity: function setCity(id, name) {
	            $("#store-selector div.mt li").eq(0).removeClass("curr");
	            $("#store-selector div.mt li").eq(0).find("em").text(name);
	            $("#store-selector div.mt li").eq(1).removeClass("hide").addClass("curr");
	            $('#store-selector [data-area="0"]').addClass("hide");
	            $('#store-selector [data-area="1"]').removeClass("hide");
	            $('#store-selector [data-area="1"] p.ac').addClass("hide");
	            $('#store-selector div.mc[data-area="1"] ul').empty();
	            $('#store-selector div.mc[data-area="2"] ul').empty();
	            $('#store-selector [data-area="2"] p.ac').removeClass("hide");
	
	            var provinceCity = provinceCityJson[id];
	            var str1 = "";
	            var str2 = "";
	            var str3 = "";
	            for (var i = 0; i < provinceCity.length; i++) {
	                var cityName = provinceCity[i]["name"];
	                var cityId = provinceCity[i]["id"];
	                if (cityName.length < 5) {
	                    str1 += '<li><a data-value="' + cityId + '" href="#none" class="selectCity">' + cityName + '</li>';
	                } else {
	                    if (cityName.length <= 11) {
	                        str2 += '<li class="long-area"><a data-value="' + cityId + '" href="#none" class="selectCity">' + cityName + '</a></li>';
	                    } else {
	                        str3 += '<li class="longer-area"><a data-value="' + cityId + '" href="#none" class="selectCity">' + cityName + '</a></li>';
	                    }
	                }
	            }
	            $('#store-selector div.mc[data-area="1"] ul').append(str1 + str2 + str3);
	
	            ipLocArray.province = id;
	        },
	
	        //选完地区之后，发送了个请求，返回了地区名字，添加到了html中
	        setArea: function setArea(id, name, firstLoad) {
	            var self = this;
	
	            $("#store-selector div.mt li").eq(1).removeClass("curr");
	            $("#store-selector div.mt li").eq(1).find("em").text(name);
	            $("#store-selector div.mt li").eq(2).removeClass("hide").addClass("curr");
	            $.ajax({
	                url: "//d.jd.com/area/get?fid=" + id,
	                dataType: "jsonp",
	                success: function success(data) {
	                    self.getAreaList_callback(data, firstLoad);
	                    ipLocArray.city = id;
	                }
	            });
	        },
	        getAreaList_callback: function getAreaList_callback(data, firstLoad) {
	            var self = this;
	
	            var areaId = "";
	            if (firstLoad) {
	                var ipLoc = self.getIpLoc();
	                if (ipLoc != null) {
	                    areaId = ipLoc.area;
	                }
	            }
	            $('#store-selector div[data-area="1"]').addClass("hide");
	            $('#store-selector div[data-area="2"]').removeClass("hide");
	            $('#store-selector div[data-area="2"] p.ac').addClass("hide");
	            $('#store-selector div.mc[data-area="2"] ul').empty();
	            var areaObj, name;
	            var str1 = "";
	            var str2 = "";
	            var str3 = "";
	            for (var i = 0; i < data.length; i++) {
	                areaObj = data[i];
	                name = areaObj.name;
	                if (name.length < 5) {
	                    str1 += "<li><a data-value='" + areaObj["id"] + "' href='#none' class='selectArea'>" + areaObj["name"] + "</a></li>";
	                } else {
	                    if (name.length <= 11) {
	                        str2 += "<li class='long-area'><a data-value='" + areaObj["id"] + "' href='#none' class='selectArea'>" + areaObj["name"] + "</a></li>";
	                    } else {
	                        str3 += "<li class='longer-area'><a data-value='" + areaObj["id"] + "' href='#none' class='selectArea'>" + areaObj["name"] + "</a></li>";
	                    }
	                }
	
	                if (areaId != "" && data[i].id.toString() == areaId) {
	                    var name = data[i].name;
	                    self.stateObj.areaName = name;
	                    $("#store-selector div.mt li").eq(0).removeClass("curr");
	                    $("#store-selector div.mt li").eq(1).removeClass("curr");
	                    $("#store-selector div.mt li").eq(2).find("em").text(name);
	                    $("#store-selector div.mt li").eq(2).removeClass("hide").addClass("curr");
	
	                    $("#store-selector div.text").html(self.stateObj.proviceName + self.stateObj.cityName + self.stateObj.areaName + "<b></b>");
	                }
	            }
	            $('#store-selector div.mc[data-area="2"] ul').append(str1 + str2 + str3);
	        },
	        getCookie: function getCookie(name) {
	            var nameEQ = name + "=";
	            var ca = document.cookie.split(';');
	            for (var i = 0; i < ca.length; i++) {
	                var c = ca[i];
	                while (c.charAt(0) == ' ') {
	                    c = c.substring(1, c.length);
	                }
	                if (c.indexOf(nameEQ) == 0) {
	                    return c.substring(nameEQ.length, c.length);
	                }
	            }
	            return null;
	        }
	    };
	
	    var iplocation = {
	        1: {
	            name: "北京",
	            root: 0,
	            djd: 1,
	            c: 72
	        },
	        2: {
	            name: "上海",
	            root: 1,
	            djd: 1,
	            c: 78
	        },
	        3: {
	            name: "天津",
	            root: 0,
	            djd: 1,
	            c: 51035
	        },
	        4: {
	            name: "重庆",
	            root: 3,
	            djd: 1,
	            c: 113
	        },
	        5: {
	            name: "河北",
	            root: 0,
	            djd: 1,
	            c: 142
	        },
	        6: {
	            name: "山西",
	            root: 0,
	            djd: 1,
	            c: 303
	        },
	        7: {
	            name: "河南",
	            root: 0,
	            djd: 1,
	            c: 412
	        },
	        8: {
	            name: "辽宁",
	            root: 0,
	            djd: 1,
	            c: 560
	        },
	        9: {
	            name: "吉林",
	            root: 0,
	            djd: 1,
	            c: 639
	        },
	        10: {
	            name: "黑龙江",
	            root: 0,
	            djd: 1,
	            c: 698
	        },
	        11: {
	            name: "内蒙古",
	            root: 0,
	            djd: 0,
	            c: 799
	        },
	        12: {
	            name: "江苏",
	            root: 1,
	            djd: 1,
	            c: 904
	        },
	        13: {
	            name: "山东",
	            root: 0,
	            djd: 1,
	            c: 1e3
	        },
	        14: {
	            name: "安徽",
	            root: 1,
	            djd: 1,
	            c: 1116
	        },
	        15: {
	            name: "浙江",
	            root: 1,
	            djd: 1,
	            c: 1158
	        },
	        16: {
	            name: "福建",
	            root: 2,
	            djd: 1,
	            c: 1303
	        },
	        17: {
	            name: "湖北",
	            root: 0,
	            djd: 1,
	            c: 1381
	        },
	        18: {
	            name: "湖南",
	            root: 2,
	            djd: 1,
	            c: 1482
	        },
	        19: {
	            name: "广东",
	            root: 2,
	            djd: 1,
	            c: 1601
	        },
	        20: {
	            name: "广西",
	            root: 2,
	            djd: 1,
	            c: 1715
	        },
	        21: {
	            name: "江西",
	            root: 2,
	            djd: 1,
	            c: 1827
	        },
	        22: {
	            name: "四川",
	            root: 3,
	            djd: 1,
	            c: 1930
	        },
	        23: {
	            name: "海南",
	            root: 2,
	            djd: 1,
	            c: 2121
	        },
	        24: {
	            name: "贵州",
	            root: 3,
	            djd: 1,
	            c: 2144
	        },
	        25: {
	            name: "云南",
	            root: 3,
	            djd: 1,
	            c: 2235
	        },
	        26: {
	            name: "西藏",
	            root: 3,
	            djd: 0,
	            c: 2951
	        },
	        27: {
	            name: "陕西",
	            root: 3,
	            djd: 1,
	            c: 2376
	        },
	        28: {
	            name: "甘肃",
	            root: 3,
	            djd: 1,
	            c: 2487
	        },
	        29: {
	            name: "青海",
	            root: 3,
	            djd: 0,
	            c: 2580
	        },
	        30: {
	            name: "宁夏",
	            root: 3,
	            djd: 1,
	            c: 2628
	        },
	        31: {
	            name: "新疆",
	            root: 3,
	            djd: 0,
	            c: 2652
	        },
	        32: {
	            name: "台湾",
	            root: 2,
	            djd: 0,
	            c: 2768
	        },
	        42: {
	            name: "香港",
	            root: 2,
	            djd: 0,
	            c: 2754
	        },
	        43: {
	            name: "澳门",
	            root: 2,
	            djd: 0,
	            c: 2770
	        },
	        84: {
	            name: "钓鱼岛",
	            root: 2,
	            djd: 0,
	            c: 84
	        }
	    },
	        provinceCityJson = {
	        1: [{
	            id: 72,
	            name: "朝阳区"
	        }, {
	            id: 2800,
	            name: "海淀区"
	        }, {
	            id: 2801,
	            name: "西城区"
	        }, {
	            id: 2802,
	            name: "东城区"
	        }, {
	            id: 2803,
	            name: "崇文区"
	        }, {
	            id: 2804,
	            name: "宣武区"
	        }, {
	            id: 2805,
	            name: "丰台区"
	        }, {
	            id: 2806,
	            name: "石景山区"
	        }, {
	            id: 2807,
	            name: "门头沟"
	        }, {
	            id: 2808,
	            name: "房山区"
	        }, {
	            id: 2809,
	            name: "通州区"
	        }, {
	            id: 2810,
	            name: "大兴区"
	        }, {
	            id: 2812,
	            name: "顺义区"
	        }, {
	            id: 2814,
	            name: "怀柔区"
	        }, {
	            id: 2816,
	            name: "密云区"
	        }, {
	            id: 2901,
	            name: "昌平区"
	        }, {
	            id: 2953,
	            name: "平谷区"
	        }, {
	            id: 3065,
	            name: "延庆县"
	        }],
	        2: [{
	            id: 2813,
	            name: "徐汇区"
	        }, {
	            id: 2815,
	            name: "长宁区"
	        }, {
	            id: 2817,
	            name: "静安区"
	        }, {
	            id: 2820,
	            name: "闸北区"
	        }, {
	            id: 2822,
	            name: "虹口区"
	        }, {
	            id: 2823,
	            name: "杨浦区"
	        }, {
	            id: 2824,
	            name: "宝山区"
	        }, {
	            id: 2825,
	            name: "闵行区"
	        }, {
	            id: 2826,
	            name: "嘉定区"
	        }, {
	            id: 2830,
	            name: "浦东新区"
	        }, {
	            id: 2833,
	            name: "青浦区"
	        }, {
	            id: 2834,
	            name: "松江区"
	        }, {
	            id: 2835,
	            name: "金山区"
	        }, {
	            id: 2836,
	            name: "南汇区"
	        }, {
	            id: 2837,
	            name: "奉贤区"
	        }, {
	            id: 2841,
	            name: "普陀区"
	        }, {
	            id: 2919,
	            name: "崇明县"
	        }, {
	            id: 78,
	            name: "黄浦区"
	        }],
	        3: [{
	            id: 51035,
	            name: "东丽区"
	        }, {
	            id: 51036,
	            name: "和平区"
	        }, {
	            id: 51037,
	            name: "河北区"
	        }, {
	            id: 51038,
	            name: "河东区"
	        }, {
	            id: 51039,
	            name: "河西区"
	        }, {
	            id: 51040,
	            name: "红桥区"
	        }, {
	            id: 51041,
	            name: "蓟县"
	        }, {
	            id: 51042,
	            name: "静海县"
	        }, {
	            id: 51043,
	            name: "南开区"
	        }, {
	            id: 51044,
	            name: "塘沽区"
	        }, {
	            id: 51045,
	            name: "西青区"
	        }, {
	            id: 51046,
	            name: "武清区"
	        }, {
	            id: 51047,
	            name: "津南区"
	        }, {
	            id: 51048,
	            name: "汉沽区"
	        }, {
	            id: 51049,
	            name: "大港区"
	        }, {
	            id: 51050,
	            name: "北辰区"
	        }, {
	            id: 51051,
	            name: "宝坻区"
	        }, {
	            id: 51052,
	            name: "宁河县"
	        }],
	        4: [{
	            id: 113,
	            name: "万州区"
	        }, {
	            id: 114,
	            name: "涪陵区"
	        }, {
	            id: 115,
	            name: "梁平县"
	        }, {
	            id: 119,
	            name: "南川区"
	        }, {
	            id: 123,
	            name: "潼南县"
	        }, {
	            id: 126,
	            name: "大足区"
	        }, {
	            id: 128,
	            name: "黔江区"
	        }, {
	            id: 129,
	            name: "武隆县"
	        }, {
	            id: 130,
	            name: "丰都县"
	        }, {
	            id: 131,
	            name: "奉节县"
	        }, {
	            id: 132,
	            name: "开县"
	        }, {
	            id: 133,
	            name: "云阳县"
	        }, {
	            id: 134,
	            name: "忠县"
	        }, {
	            id: 135,
	            name: "巫溪县"
	        }, {
	            id: 136,
	            name: "巫山县"
	        }, {
	            id: 137,
	            name: "石柱县"
	        }, {
	            id: 138,
	            name: "彭水县"
	        }, {
	            id: 139,
	            name: "垫江县"
	        }, {
	            id: 140,
	            name: "酉阳县"
	        }, {
	            id: 141,
	            name: "秀山县"
	        }, {
	            id: 48131,
	            name: "璧山县"
	        }, {
	            id: 48132,
	            name: "荣昌县"
	        }, {
	            id: 48133,
	            name: "铜梁县"
	        }, {
	            id: 48201,
	            name: "合川区"
	        }, {
	            id: 48202,
	            name: "巴南区"
	        }, {
	            id: 48203,
	            name: "北碚区"
	        }, {
	            id: 48204,
	            name: "江津区"
	        }, {
	            id: 48205,
	            name: "渝北区"
	        }, {
	            id: 48206,
	            name: "长寿区"
	        }, {
	            id: 48207,
	            name: "永川区"
	        }, {
	            id: 50950,
	            name: "江北区"
	        }, {
	            id: 50951,
	            name: "南岸区"
	        }, {
	            id: 50952,
	            name: "九龙坡区"
	        }, {
	            id: 50953,
	            name: "沙坪坝区"
	        }, {
	            id: 50954,
	            name: "大渡口区"
	        }, {
	            id: 50995,
	            name: "綦江区"
	        }, {
	            id: 51026,
	            name: "渝中区"
	        }, {
	            id: 51027,
	            name: "高新区"
	        }, {
	            id: 51028,
	            name: "北部新区"
	        }, {
	            id: 4164,
	            name: "城口县"
	        }, {
	            id: 3076,
	            name: "高新区"
	        }],
	        5: [{
	            id: 142,
	            name: "石家庄市"
	        }, {
	            id: 148,
	            name: "邯郸市"
	        }, {
	            id: 164,
	            name: "邢台市"
	        }, {
	            id: 199,
	            name: "保定市"
	        }, {
	            id: 224,
	            name: "张家口市"
	        }, {
	            id: 239,
	            name: "承德市"
	        }, {
	            id: 248,
	            name: "秦皇岛市"
	        }, {
	            id: 258,
	            name: "唐山市"
	        }, {
	            id: 264,
	            name: "沧州市"
	        }, {
	            id: 274,
	            name: "廊坊市"
	        }, {
	            id: 275,
	            name: "衡水市"
	        }],
	        6: [{
	            id: 303,
	            name: "太原市"
	        }, {
	            id: 309,
	            name: "大同市"
	        }, {
	            id: 318,
	            name: "阳泉市"
	        }, {
	            id: 325,
	            name: "晋城市"
	        }, {
	            id: 330,
	            name: "朔州市"
	        }, {
	            id: 336,
	            name: "晋中市"
	        }, {
	            id: 350,
	            name: "忻州市"
	        }, {
	            id: 368,
	            name: "吕梁市"
	        }, {
	            id: 379,
	            name: "临汾市"
	        }, {
	            id: 398,
	            name: "运城市"
	        }, {
	            id: 3074,
	            name: "长治市"
	        }],
	        7: [{
	            id: 412,
	            name: "郑州市"
	        }, {
	            id: 420,
	            name: "开封市"
	        }, {
	            id: 427,
	            name: "洛阳市"
	        }, {
	            id: 438,
	            name: "平顶山市"
	        }, {
	            id: 446,
	            name: "焦作市"
	        }, {
	            id: 454,
	            name: "鹤壁市"
	        }, {
	            id: 458,
	            name: "新乡市"
	        }, {
	            id: 468,
	            name: "安阳市"
	        }, {
	            id: 475,
	            name: "濮阳市"
	        }, {
	            id: 482,
	            name: "许昌市"
	        }, {
	            id: 489,
	            name: "漯河市"
	        }, {
	            id: 495,
	            name: "三门峡市"
	        }, {
	            id: 502,
	            name: "南阳市"
	        }, {
	            id: 517,
	            name: "商丘市"
	        }, {
	            id: 527,
	            name: "周口市"
	        }, {
	            id: 538,
	            name: "驻马店市"
	        }, {
	            id: 549,
	            name: "信阳市"
	        }, {
	            id: 2780,
	            name: "济源市"
	        }],
	        8: [{
	            id: 560,
	            name: "沈阳市"
	        }, {
	            id: 573,
	            name: "大连市"
	        }, {
	            id: 579,
	            name: "鞍山市"
	        }, {
	            id: 584,
	            name: "抚顺市"
	        }, {
	            id: 589,
	            name: "本溪市"
	        }, {
	            id: 593,
	            name: "丹东市"
	        }, {
	            id: 598,
	            name: "锦州市"
	        }, {
	            id: 604,
	            name: "葫芦岛市"
	        }, {
	            id: 609,
	            name: "营口市"
	        }, {
	            id: 613,
	            name: "盘锦市"
	        }, {
	            id: 617,
	            name: "阜新市"
	        }, {
	            id: 621,
	            name: "辽阳市"
	        }, {
	            id: 632,
	            name: "朝阳市"
	        }, {
	            id: 6858,
	            name: "铁岭市"
	        }],
	        9: [{
	            id: 639,
	            name: "长春市"
	        }, {
	            id: 644,
	            name: "吉林市"
	        }, {
	            id: 651,
	            name: "四平市"
	        }, {
	            id: 2992,
	            name: "辽源市"
	        }, {
	            id: 657,
	            name: "通化市"
	        }, {
	            id: 664,
	            name: "白山市"
	        }, {
	            id: 674,
	            name: "松原市"
	        }, {
	            id: 681,
	            name: "白城市"
	        }, {
	            id: 687,
	            name: "延边州"
	        }],
	        10: [{
	            id: 727,
	            name: "鹤岗市"
	        }, {
	            id: 731,
	            name: "双鸭山市"
	        }, {
	            id: 737,
	            name: "鸡西市"
	        }, {
	            id: 742,
	            name: "大庆市"
	        }, {
	            id: 753,
	            name: "伊春市"
	        }, {
	            id: 757,
	            name: "牡丹江市"
	        }, {
	            id: 765,
	            name: "佳木斯市"
	        }, {
	            id: 773,
	            name: "七台河市"
	        }, {
	            id: 776,
	            name: "黑河市"
	        }, {
	            id: 782,
	            name: "绥化市"
	        }, {
	            id: 793,
	            name: "大兴安岭地区"
	        }, {
	            id: 698,
	            name: "哈尔滨市"
	        }, {
	            id: 712,
	            name: "齐齐哈尔市"
	        }],
	        11: [{
	            id: 799,
	            name: "呼和浩特市"
	        }, {
	            id: 805,
	            name: "包头市"
	        }, {
	            id: 810,
	            name: "乌海市"
	        }, {
	            id: 812,
	            name: "赤峰市"
	        }, {
	            id: 823,
	            name: "乌兰察布市"
	        }, {
	            id: 835,
	            name: "锡林郭勒盟"
	        }, {
	            id: 848,
	            name: "呼伦贝尔市"
	        }, {
	            id: 870,
	            name: "鄂尔多斯市"
	        }, {
	            id: 880,
	            name: "巴彦淖尔市"
	        }, {
	            id: 891,
	            name: "阿拉善盟"
	        }, {
	            id: 895,
	            name: "兴安盟"
	        }, {
	            id: 902,
	            name: "通辽市"
	        }],
	        12: [{
	            id: 904,
	            name: "南京市"
	        }, {
	            id: 911,
	            name: "徐州市"
	        }, {
	            id: 919,
	            name: "连云港市"
	        }, {
	            id: 925,
	            name: "淮安市"
	        }, {
	            id: 933,
	            name: "宿迁市"
	        }, {
	            id: 939,
	            name: "盐城市"
	        }, {
	            id: 951,
	            name: "扬州市"
	        }, {
	            id: 959,
	            name: "泰州市"
	        }, {
	            id: 965,
	            name: "南通市"
	        }, {
	            id: 972,
	            name: "镇江市"
	        }, {
	            id: 978,
	            name: "常州市"
	        }, {
	            id: 984,
	            name: "无锡市"
	        }, {
	            id: 988,
	            name: "苏州市"
	        }],
	        13: [{
	            id: 2900,
	            name: "济宁市"
	        }, {
	            id: 1e3,
	            name: "济南市"
	        }, {
	            id: 1007,
	            name: "青岛市"
	        }, {
	            id: 1016,
	            name: "淄博市"
	        }, {
	            id: 1022,
	            name: "枣庄市"
	        }, {
	            id: 1025,
	            name: "东营市"
	        }, {
	            id: 1032,
	            name: "潍坊市"
	        }, {
	            id: 1042,
	            name: "烟台市"
	        }, {
	            id: 1053,
	            name: "威海市"
	        }, {
	            id: 1058,
	            name: "莱芜市"
	        }, {
	            id: 1060,
	            name: "德州市"
	        }, {
	            id: 1072,
	            name: "临沂市"
	        }, {
	            id: 1081,
	            name: "聊城市"
	        }, {
	            id: 1090,
	            name: "滨州市"
	        }, {
	            id: 1099,
	            name: "菏泽市"
	        }, {
	            id: 1108,
	            name: "日照市"
	        }, {
	            id: 1112,
	            name: "泰安市"
	        }],
	        14: [{
	            id: 1151,
	            name: "黄山市"
	        }, {
	            id: 1159,
	            name: "滁州市"
	        }, {
	            id: 1167,
	            name: "阜阳市"
	        }, {
	            id: 1174,
	            name: "亳州市"
	        }, {
	            id: 1180,
	            name: "宿州市"
	        }, {
	            id: 1201,
	            name: "池州市"
	        }, {
	            id: 1206,
	            name: "六安市"
	        }, {
	            id: 2971,
	            name: "宣城市"
	        }, {
	            id: 1114,
	            name: "铜陵市"
	        }, {
	            id: 1116,
	            name: "合肥市"
	        }, {
	            id: 1121,
	            name: "淮南市"
	        }, {
	            id: 1124,
	            name: "淮北市"
	        }, {
	            id: 1127,
	            name: "芜湖市"
	        }, {
	            id: 1132,
	            name: "蚌埠市"
	        }, {
	            id: 1137,
	            name: "马鞍山市"
	        }, {
	            id: 1140,
	            name: "安庆市"
	        }],
	        15: [{
	            id: 1158,
	            name: "宁波市"
	        }, {
	            id: 1273,
	            name: "衢州市"
	        }, {
	            id: 1280,
	            name: "丽水市"
	        }, {
	            id: 1290,
	            name: "台州市"
	        }, {
	            id: 1298,
	            name: "舟山市"
	        }, {
	            id: 1213,
	            name: "杭州市"
	        }, {
	            id: 1233,
	            name: "温州市"
	        }, {
	            id: 1243,
	            name: "嘉兴市"
	        }, {
	            id: 1250,
	            name: "湖州市"
	        }, {
	            id: 1255,
	            name: "绍兴市"
	        }, {
	            id: 1262,
	            name: "金华市"
	        }],
	        16: [{
	            id: 1303,
	            name: "福州市"
	        }, {
	            id: 1315,
	            name: "厦门市"
	        }, {
	            id: 1317,
	            name: "三明市"
	        }, {
	            id: 1329,
	            name: "莆田市"
	        }, {
	            id: 1332,
	            name: "泉州市"
	        }, {
	            id: 1341,
	            name: "漳州市"
	        }, {
	            id: 1352,
	            name: "南平市"
	        }, {
	            id: 1362,
	            name: "龙岩市"
	        }, {
	            id: 1370,
	            name: "宁德市"
	        }],
	        17: [{
	            id: 1432,
	            name: "孝感市"
	        }, {
	            id: 1441,
	            name: "黄冈市"
	        }, {
	            id: 1458,
	            name: "咸宁市"
	        }, {
	            id: 1466,
	            name: "恩施州"
	        }, {
	            id: 1475,
	            name: "鄂州市"
	        }, {
	            id: 1477,
	            name: "荆门市"
	        }, {
	            id: 1479,
	            name: "随州市"
	        }, {
	            id: 3154,
	            name: "神农架林区"
	        }, {
	            id: 1381,
	            name: "武汉市"
	        }, {
	            id: 1387,
	            name: "黄石市"
	        }, {
	            id: 1396,
	            name: "襄阳市"
	        }, {
	            id: 1405,
	            name: "十堰市"
	        }, {
	            id: 1413,
	            name: "荆州市"
	        }, {
	            id: 1421,
	            name: "宜昌市"
	        }, {
	            id: 2922,
	            name: "潜江市"
	        }, {
	            id: 2980,
	            name: "天门市"
	        }, {
	            id: 2983,
	            name: "仙桃市"
	        }],
	        18: [{
	            id: 4250,
	            name: "耒阳市"
	        }, {
	            id: 1482,
	            name: "长沙市"
	        }, {
	            id: 1488,
	            name: "株洲市"
	        }, {
	            id: 1495,
	            name: "湘潭市"
	        }, {
	            id: 1499,
	            name: "韶山市"
	        }, {
	            id: 1501,
	            name: "衡阳市"
	        }, {
	            id: 1511,
	            name: "邵阳市"
	        }, {
	            id: 1522,
	            name: "岳阳市"
	        }, {
	            id: 1530,
	            name: "常德市"
	        }, {
	            id: 1540,
	            name: "张家界市"
	        }, {
	            id: 1544,
	            name: "郴州市"
	        }, {
	            id: 1555,
	            name: "益阳市"
	        }, {
	            id: 1560,
	            name: "永州市"
	        }, {
	            id: 1574,
	            name: "怀化市"
	        }, {
	            id: 1586,
	            name: "娄底市"
	        }, {
	            id: 1592,
	            name: "湘西州"
	        }],
	        19: [{
	            id: 1601,
	            name: "广州市"
	        }, {
	            id: 1607,
	            name: "深圳市"
	        }, {
	            id: 1609,
	            name: "珠海市"
	        }, {
	            id: 1611,
	            name: "汕头市"
	        }, {
	            id: 1617,
	            name: "韶关市"
	        }, {
	            id: 1627,
	            name: "河源市"
	        }, {
	            id: 1634,
	            name: "梅州市"
	        }, {
	            id: 1709,
	            name: "揭阳市"
	        }, {
	            id: 1643,
	            name: "惠州市"
	        }, {
	            id: 1650,
	            name: "汕尾市"
	        }, {
	            id: 1655,
	            name: "东莞市"
	        }, {
	            id: 1657,
	            name: "中山市"
	        }, {
	            id: 1659,
	            name: "江门市"
	        }, {
	            id: 1666,
	            name: "佛山市"
	        }, {
	            id: 1672,
	            name: "阳江市"
	        }, {
	            id: 1677,
	            name: "湛江市"
	        }, {
	            id: 1684,
	            name: "茂名市"
	        }, {
	            id: 1690,
	            name: "肇庆市"
	        }, {
	            id: 1698,
	            name: "云浮市"
	        }, {
	            id: 1704,
	            name: "清远市"
	        }, {
	            id: 1705,
	            name: "潮州市"
	        }],
	        20: [{
	            id: 3168,
	            name: "崇左市"
	        }, {
	            id: 1715,
	            name: "南宁市"
	        }, {
	            id: 1720,
	            name: "柳州市"
	        }, {
	            id: 1726,
	            name: "桂林市"
	        }, {
	            id: 1740,
	            name: "梧州市"
	        }, {
	            id: 1746,
	            name: "北海市"
	        }, {
	            id: 1749,
	            name: "防城港市"
	        }, {
	            id: 1753,
	            name: "钦州市"
	        }, {
	            id: 1757,
	            name: "贵港市"
	        }, {
	            id: 1761,
	            name: "玉林市"
	        }, {
	            id: 1792,
	            name: "贺州市"
	        }, {
	            id: 1806,
	            name: "百色市"
	        }, {
	            id: 1818,
	            name: "河池市"
	        }, {
	            id: 3044,
	            name: "来宾市"
	        }],
	        21: [{
	            id: 1827,
	            name: "南昌市"
	        }, {
	            id: 1832,
	            name: "景德镇市"
	        }, {
	            id: 1836,
	            name: "萍乡市"
	        }, {
	            id: 1842,
	            name: "新余市"
	        }, {
	            id: 1845,
	            name: "九江市"
	        }, {
	            id: 1857,
	            name: "鹰潭市"
	        }, {
	            id: 1861,
	            name: "上饶市"
	        }, {
	            id: 1874,
	            name: "宜春市"
	        }, {
	            id: 1885,
	            name: "抚州市"
	        }, {
	            id: 1898,
	            name: "吉安市"
	        }, {
	            id: 1911,
	            name: "赣州市"
	        }],
	        22: [{
	            id: 2103,
	            name: "凉山州"
	        }, {
	            id: 1930,
	            name: "成都市"
	        }, {
	            id: 1946,
	            name: "自贡市"
	        }, {
	            id: 1950,
	            name: "攀枝花市"
	        }, {
	            id: 1954,
	            name: "泸州市"
	        }, {
	            id: 1960,
	            name: "绵阳市"
	        }, {
	            id: 1962,
	            name: "德阳市"
	        }, {
	            id: 1977,
	            name: "广元市"
	        }, {
	            id: 1983,
	            name: "遂宁市"
	        }, {
	            id: 1988,
	            name: "内江市"
	        }, {
	            id: 1993,
	            name: "乐山市"
	        }, {
	            id: 2005,
	            name: "宜宾市"
	        }, {
	            id: 2016,
	            name: "广安市"
	        }, {
	            id: 2022,
	            name: "南充市"
	        }, {
	            id: 2033,
	            name: "达州市"
	        }, {
	            id: 2042,
	            name: "巴中市"
	        }, {
	            id: 2047,
	            name: "雅安市"
	        }, {
	            id: 2058,
	            name: "眉山市"
	        }, {
	            id: 2065,
	            name: "资阳市"
	        }, {
	            id: 2070,
	            name: "阿坝州"
	        }, {
	            id: 2084,
	            name: "甘孜州"
	        }],
	        23: [{
	            id: 3690,
	            name: "三亚市"
	        }, {
	            id: 3698,
	            name: "文昌市"
	        }, {
	            id: 3699,
	            name: "五指山市"
	        }, {
	            id: 3701,
	            name: "临高县"
	        }, {
	            id: 3702,
	            name: "澄迈县"
	        }, {
	            id: 3703,
	            name: "定安县"
	        }, {
	            id: 3704,
	            name: "屯昌县"
	        }, {
	            id: 3705,
	            name: "昌江县"
	        }, {
	            id: 3706,
	            name: "白沙县"
	        }, {
	            id: 3707,
	            name: "琼中县"
	        }, {
	            id: 3708,
	            name: "陵水县"
	        }, {
	            id: 3709,
	            name: "保亭县"
	        }, {
	            id: 3710,
	            name: "乐东县"
	        }, {
	            id: 3711,
	            name: "三沙市"
	        }, {
	            id: 2121,
	            name: "海口市"
	        }, {
	            id: 3115,
	            name: "琼海市"
	        }, {
	            id: 3137,
	            name: "万宁市"
	        }, {
	            id: 3173,
	            name: "东方市"
	        }, {
	            id: 3034,
	            name: "儋州市"
	        }],
	        24: [{
	            id: 2144,
	            name: "贵阳市"
	        }, {
	            id: 2150,
	            name: "六盘水市"
	        }, {
	            id: 2155,
	            name: "遵义市"
	        }, {
	            id: 2169,
	            name: "铜仁市"
	        }, {
	            id: 2180,
	            name: "毕节市"
	        }, {
	            id: 2189,
	            name: "安顺市"
	        }, {
	            id: 2196,
	            name: "黔西南州"
	        }, {
	            id: 2205,
	            name: "黔东南州"
	        }, {
	            id: 2222,
	            name: "黔南州"
	        }],
	        25: [{
	            id: 4108,
	            name: "迪庆州"
	        }, {
	            id: 2235,
	            name: "昆明市"
	        }, {
	            id: 2247,
	            name: "曲靖市"
	        }, {
	            id: 2258,
	            name: "玉溪市"
	        }, {
	            id: 2270,
	            name: "昭通市"
	        }, {
	            id: 2281,
	            name: "普洱市"
	        }, {
	            id: 2291,
	            name: "临沧市"
	        }, {
	            id: 2298,
	            name: "保山市"
	        }, {
	            id: 2304,
	            name: "丽江市"
	        }, {
	            id: 2309,
	            name: "文山州"
	        }, {
	            id: 2318,
	            name: "红河州"
	        }, {
	            id: 2332,
	            name: "西双版纳州"
	        }, {
	            id: 2336,
	            name: "楚雄州"
	        }, {
	            id: 2347,
	            name: "大理州"
	        }, {
	            id: 2360,
	            name: "德宏州"
	        }, {
	            id: 2366,
	            name: "怒江州"
	        }],
	        26: [{
	            id: 3970,
	            name: "阿里地区"
	        }, {
	            id: 3971,
	            name: "林芝地区"
	        }, {
	            id: 2951,
	            name: "拉萨市"
	        }, {
	            id: 3107,
	            name: "那曲地区"
	        }, {
	            id: 3129,
	            name: "山南地区"
	        }, {
	            id: 3138,
	            name: "昌都地区"
	        }, {
	            id: 3144,
	            name: "日喀则地区"
	        }],
	        27: [{
	            id: 2428,
	            name: "延安市"
	        }, {
	            id: 2442,
	            name: "汉中市"
	        }, {
	            id: 2454,
	            name: "榆林市"
	        }, {
	            id: 2468,
	            name: "商洛市"
	        }, {
	            id: 2476,
	            name: "安康市"
	        }, {
	            id: 2376,
	            name: "西安市"
	        }, {
	            id: 2386,
	            name: "铜川市"
	        }, {
	            id: 2390,
	            name: "宝鸡市"
	        }, {
	            id: 2402,
	            name: "咸阳市"
	        }, {
	            id: 2416,
	            name: "渭南市"
	        }],
	        28: [{
	            id: 2525,
	            name: "庆阳市"
	        }, {
	            id: 2534,
	            name: "陇南市"
	        }, {
	            id: 2544,
	            name: "武威市"
	        }, {
	            id: 2549,
	            name: "张掖市"
	        }, {
	            id: 2556,
	            name: "酒泉市"
	        }, {
	            id: 2564,
	            name: "甘南州"
	        }, {
	            id: 2573,
	            name: "临夏州"
	        }, {
	            id: 3080,
	            name: "定西市"
	        }, {
	            id: 2487,
	            name: "兰州市"
	        }, {
	            id: 2492,
	            name: "金昌市"
	        }, {
	            id: 2495,
	            name: "白银市"
	        }, {
	            id: 2501,
	            name: "天水市"
	        }, {
	            id: 2509,
	            name: "嘉峪关市"
	        }, {
	            id: 2518,
	            name: "平凉市"
	        }],
	        29: [{
	            id: 2580,
	            name: "西宁市"
	        }, {
	            id: 2585,
	            name: "海东地区"
	        }, {
	            id: 2592,
	            name: "海北州"
	        }, {
	            id: 2597,
	            name: "黄南州"
	        }, {
	            id: 2603,
	            name: "海南州"
	        }, {
	            id: 2605,
	            name: "果洛州"
	        }, {
	            id: 2612,
	            name: "玉树州"
	        }, {
	            id: 2620,
	            name: "海西州"
	        }],
	        30: [{
	            id: 2628,
	            name: "银川市"
	        }, {
	            id: 2632,
	            name: "石嘴山市"
	        }, {
	            id: 2637,
	            name: "吴忠市"
	        }, {
	            id: 2644,
	            name: "固原市"
	        }, {
	            id: 3071,
	            name: "中卫市"
	        }],
	        31: [{
	            id: 4110,
	            name: "五家渠市"
	        }, {
	            id: 4163,
	            name: "博尔塔拉蒙古自治州阿拉山口口岸"
	        }, {
	            id: 15945,
	            name: "阿拉尔市"
	        }, {
	            id: 15946,
	            name: "图木舒克市"
	        }, {
	            id: 2652,
	            name: "乌鲁木齐市"
	        }, {
	            id: 2654,
	            name: "克拉玛依市"
	        }, {
	            id: 2656,
	            name: "石河子市"
	        }, {
	            id: 2658,
	            name: "吐鲁番地区"
	        }, {
	            id: 2662,
	            name: "哈密地区"
	        }, {
	            id: 2666,
	            name: "和田地区"
	        }, {
	            id: 2675,
	            name: "阿克苏地区"
	        }, {
	            id: 2686,
	            name: "喀什地区"
	        }, {
	            id: 2699,
	            name: "克孜勒苏州"
	        }, {
	            id: 2704,
	            name: "巴音郭楞州"
	        }, {
	            id: 2714,
	            name: "昌吉州"
	        }, {
	            id: 2723,
	            name: "博尔塔拉州"
	        }, {
	            id: 2727,
	            name: "伊犁州"
	        }, {
	            id: 2736,
	            name: "塔城地区"
	        }, {
	            id: 2744,
	            name: "阿勒泰地区"
	        }],
	        32: [{
	            id: 2768,
	            name: "台湾市"
	        }],
	        42: [{
	            id: 2754,
	            name: "香港特别行政区"
	        }],
	        43: [{
	            id: 2770,
	            name: "澳门市"
	        }],
	        84: [{
	            id: 1310,
	            name: "钓鱼岛"
	        }]
	    };
	
	    module.exports = selector;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;"use strict";
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(3);
	    var comment = {
	        init: function init(arg) {
	            var self = this;
	            self.ajaxComment(arg);
	        },
	        getCommentSku: function getCommentSku() {
	            var skuList = "";
	            $(".hasComment").each(function () {
	                var skuid = $.trim($(this).attr("skuid"));
	                skuid = skuid.substring(2, skuid.length);
	                skuList += "," + skuid;
	            });
	            skuList = skuList.substring(1, skuList.length);
	            return skuList;
	        },
	        ajaxComment: function ajaxComment(arg) {
	            var self = this;
	            var skuList = self.getCommentSku();
	            if (skuList == "") {
	                return false;
	            }
	            $.ajax({
	                url: Config.serviceInterface.getCommentByskuIds,
	                data: {
	                    "skuids": skuList
	                },
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    for (var i = 0; i < data.length; i++) {
	                        var id = "J_" + data[i].id;
	                        var count = data[i].count;
	                        if (count >= 10000) {
	                            if (count >= 100000) {
	                                count = parseInt(count / 10000) + '万+';
	                            } else {
	                                count = parseInt(count / 1000) / 10 + '万+';
	                            }
	                        } else if (count >= 100 && count < 10000) {
	                            count = parseInt(count / 100) + '00+';
	                        } else if (count >= 10 && count < 100) {
	                            count = parseInt(count / 10) + '0+';
	                        } else if (count > 0) {
	                            count = count;
	                        } else {
	                            count = '0';
	                        }
	
	                        $(".hasComment").each(function () {
	                            if ($(this).attr("skuid") == id) {
	                                if (arg && arg == "indexV2") {
	                                    $(this).find(".comment").append('<span class="cNum"><b class="comment_num">' + count + '</b> 条评价</span>');
	                                } else {
	                                    //$(this).find(".comment").html("<i></i><span>" + count + "</span>");
	                                    $(this).find(".comment").html('<span class="cNum"><b class="comment_num">' + count + '</b> 条评价</span>');
	                                }
	                            }
	                        });
	                    }
	                }
	            });
	        }
	    };
	    exports.fn = comment;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var timeModel = __webpack_require__(21);
	    var indexV2Model = __webpack_require__(52);
	    var priceV2 = __webpack_require__(48);
	    var ticker = __webpack_require__(22);
	    var lazyload = __webpack_require__(2);
	    var CheckLogin = __webpack_require__(53);
	    var tplModel = __webpack_require__(28);
	
	    var indexV2Module = {
	        init: function init() {
	            var self = this;
	            self.loadGuessYouLike();
	            self.addEvent();
	            self.bindMouseHoverEvt();
	            self.addSaleFloorEvent();
	
	            // self.initHerizonalScroll();
	        },
	        initHerizonalScroll: function initHerizonalScroll() {
	            var options = {
	                slidee: $('.slidee'),
	                horizontal: true,
	                itemNav: 'basic',
	                speed: 300,
	                mouseDragging: 1,
	                touchDragging: 1,
	                scrollBar: $('#scrollbar'),
	                dragHandle: true,
	                minHandleSize: 300,
	                backward: $('#prev'),
	                forward: $('#next'),
	                moveBy: 3500
	            };
	            var frame = new Sly('#frame', options).init();
	        },
	        bindMouseHoverEvt: function bindMouseHoverEvt() {
	            $('.guarantee .more_info').on('mouseenter', function () {
	                $(this).children().addClass('curr');
	            }).on('mouseleave', function () {
	                $(this).children().removeClass('curr');
	            });
	        },
	        addEvent: function addEvent() {
	            //左右氛围图
	            if ($("#lTone").attr("imgUrl")) {
	                var url = $("#lTone").attr("imgUrl");
	                var src = $("#lTone").attr("textUrl") || "#";
	                var clstag = $("#lTone").attr("clstag") || "";
	                $(".slide").append('<div class="l-tone">' + '<a href="' + src + '" clstag="' + clstag + '" target="_blank">' + '<img src="' + url + '">' + '</a>' + '</div>');
	            }
	
	            if ($("#rTone").attr("imgUrl")) {
	                var url = $("#rTone").attr("imgUrl");
	                var src = $("#rTone").attr("textUrl") || "#";
	                var clstag = $("#rTone").attr("clstag") || "";
	                $(".slide").append('<div class="r-tone">' + '<a href="' + src + '" clstag="' + clstag + '" target="_blank">' + '<img src="' + url + '">' + '</a>' + '</div>');
	            }
	
	            //玩具乐器等类似楼层tab切换
	            $('.floor').delegate('.tabs .tab', 'click', function () {
	                var self = $(this);
	                var index = self.index();
	                if (self.siblings('.tab').length > 0) {
	                    self.siblings('.tab').removeClass('curr');
	                }
	                self.addClass('curr');
	                self.parents('.tabs').children('.tab-contents').addClass('hide');
	                self.parents('.tabs').children('.tab-contents:eq(' + index + ')').removeClass('hide');
	            });
	
	            //品牌商标翻转效果
	            $('.floor').delegate('.brand', 'mouseover', function () {
	                var self = $(this);
	                self.find('img').addClass('hide');
	                self.find('.name').removeClass('hide');
	            }).delegate('.brand', 'mouseleave', function () {
	                var self = $(this);
	                self.find('img').removeClass('hide');
	                self.find('.name').addClass('hide');
	            });
	
	            //顶部广告关闭按钮
	            $("#topbanner-close").bind("click", function () {
	                $(".top-banner").remove();
	            });
	
	            //轮播图旁的切换
	            $(".slideRight .control a").on("mouseover", function () {
	                $(this).addClass("curr").siblings().removeClass("curr");
	
	                var idx = $(this).index();
	
	                var moveX = -242 * idx;
	                $(this).parents(".sr-service").find("ul").animate({
	                    "marginLeft": moveX
	                }, 300);
	            });
	
	            //特卖
	            // $(".temai").delegate(".tab li", "click", function () {
	            //     $(this).addClass("curr").siblings().removeClass("curr");
	            //
	            //     var idx = $(this).index();
	            //     $(this).parents(".tabs").find(".tab-cnt").eq(idx).removeClass("hide").siblings().addClass("hide");
	            // });
	
	            //全球直采
	            $(".zhicai").delegate(".tab li", "click", function () {
	                $(this).addClass("curr").siblings().removeClass("curr");
	
	                var idx = $(this).index();
	                $(this).parents(".tabs").find(".tab-cnt").eq(idx).removeClass("hide").siblings().addClass("hide");
	            });
	
	            //全球名店
	            var t = null;
	            $(".mingdian").delegate(".saleSwitch .ct", "mouseenter", function () {
	                var _this = this;
	
	                if (t != null) {
	                    clearTimeout(t);
	                }
	                var idx = $(_this).index();
	                $(_this).addClass("curr").siblings().removeClass("curr");
	
	                t = setTimeout(function () {
	                    $(_this).parents(".saleSwitch").find(".sales a").eq(idx).removeClass("hide").siblings().addClass("hide");
	                }, 200);
	            });
	        },
	        addSaleFloorEvent: function addSaleFloorEvent() {
	            /*特卖楼层交互*/
	            var specialsSaleInput = $("#specialsSaleJson");
	            if (specialsSaleInput.length <= 0) {
	                return false;
	            }
	
	            var specialsSaleJson = $.parseJSON(specialsSaleInput.val());
	
	            var cacheCurTime = specialsSaleJson.currentTime;
	            var cacheRange = 5 * 60 * 1000; //5分钟的服务器缓存时间,毫秒
	            var maxCacheTime = cacheCurTime + cacheRange;
	
	            var roundArray = specialsSaleJson.round;
	
	            var bgTime = null,
	                idx = 0;
	            for (var i = 0; i < roundArray.length; i++) {
	                idx = i;
	                var beginTime = roundArray[i].beginTime;
	                var endTime = roundArray[i].endTime;
	
	                if (cacheCurTime >= beginTime) {
	                    //缓存时间大于开始时间，说明缓存不会影响活动开始，直接跳过
	                } else if (maxCacheTime >= beginTime) {
	                    //缓存时间小于开始时间，则将缓存时间加5分钟和开始时间对比，若大于开始时间，则有可能活动已经开始，需要向服务器请求获取准确时间再对比
	                    bgTime = beginTime;
	                    break;
	                }
	            }
	
	            timeModel.ajaxGetTime(null, function (data) {
	                var serverTime = new Date(data.timeNow).getTime();
	
	                // idx = $(".temai .tab li.curr").index();
	                idx = 0; //only one tab
	                endTime = roundArray[idx].endTime;
	                pName = roundArray[idx].pName;
	
	                if (bgTime != null && serverTime >= bgTime) {
	                    //服务器时间大于开始时间，进行tab修正
	                    reviseTab(idx, serverTime, pName);
	                } else {
	                    addItemCountdown(idx, serverTime);
	                }
	                doTicker(idx, endTime, serverTime);
	                afterRevise(idx, serverTime);
	            });
	
	            function afterRevise(currIdx, serverTime) {
	                //预告不显示进度
	                initProcess(currIdx, serverTime);
	                //请求价格、倒计时
	                priceV2.init(".temai");
	                lazyload.fn.init();
	            }
	
	            /**
	             *
	             * @param currIdx 修正后的序号
	             * currIdx=1,选中第一个tab页
	             * currIdx=2,选中第二个tab页，关闭第一个tab页
	             * currIdx=3,选中第二个tab页，关闭第一个tab页
	             * @param serverTime 当前时间
	             * @param pName 已结束名称
	             */
	            function reviseTab(currIdx, serverTime, pName) {
	                var liObj = $(".temai .tab li");
	                var cntObj = $(".temai .tab-cnt");
	
	                // liObj.eq(currIdx).find(".tit").text(pName);
	                liObj.eq(currIdx).addClass("curr").siblings().removeClass("curr");
	                cntObj.eq(currIdx).removeClass("hide").siblings().addClass("hide");
	                cntObj.eq(currIdx).find("li").attr("status", "0");
	
	                addItemCountdown(currIdx, serverTime);
	
	                for (var i = currIdx - 1; i >= 0; i--) {
	                    liObj.eq(i).attr("status", "0").addClass("finish");
	                    cntObj.eq(i).find("li").attr("status", "0");
	                }
	            }
	
	            function addItemCountdown(currIdx, serverTime) {
	                var liList = $(".temai .tab li").eq(currIdx).siblings("li").not(".finish");
	                if (serverTime < roundArray[currIdx].beginTime) {
	                    liList = $(".temai .tab li").not(".finish");
	                }
	
	                liList.each(function () {
	                    var idx = $(this).index();
	                    var beginTime = roundArray[idx].beginTime;
	                    var duringSecond = (beginTime - serverTime) / 1000;
	                    var secondcount = parseInt(duringSecond);
	
	                    $(".temai .tab-cnt").eq(idx).find("li .salePrice").after('<span secondcount="' + secondcount + '" render_type="temai" class="countdown"></span>');
	                });
	            }
	
	            function doTicker(currIdx, endTime, serverTime) {
	                var duringSecond = (endTime - serverTime) / 1000;
	                if (duringSecond > 0 && serverTime >= roundArray[currIdx].beginTime) {
	                    var secondcount = parseInt(duringSecond);
	                    $(".temai .tab li").eq(currIdx).find(".tit").after('<span class="split"></span><span class="timeTag">仅剩</span><span secondcount="' + secondcount + '"></span>');
	                }
	
	                ticker.init();
	            }
	
	            function initProcess(currIdx, serverTime) {
	                /*if (serverTime < roundArray[currIdx].beginTime) {
	                    return false;
	                }*/
	
	                var promoIds = "";
	                $(".temai .tab-cnt").eq(currIdx).find("[promoid]").each(function () {
	                    var promoId = $(this).attr("promoid");
	                    promoIds = promoIds + promoId + ",";
	                });
	                promoIds = promoIds.substring(0, promoIds.length - 1);
	
	                var args = {
	                    "ids": promoIds
	                };
	                indexV2Model.ajaxGetProcess(args, function (data) {
	                    for (var i = 0; i < data.length; i++) {
	                        $(".temai").find("[promoid='" + data[i].id + "']").each(function () {
	                            var total = data[i].n;
	                            var left = data[i].nb;
	                            var percent = parseInt((1 - left / total) * 100);
	
	                            $(this).find(".process").remove();
	                            $(this).find(".salePrice").after('<span class="process"><span class="txt">已售' + percent + '%</span><span class="pBar"><span class="p-top" style="width: ' + percent + '%;"></span><span class="p-btm"></span></span></span>');
	
	                            if (percent == 100) {
	                                $(this).addClass("soldout");
	                                $(this).find(".tag").html("已抢光<i></i>");
	                            }
	                        });
	                    }
	                });
	            }
	        },
	        loadGuessYouLike: function loadGuessYouLike() {
	            var self = this;
	            /*
	                1.先判断是否登录，如果登录的话拿到pin
	                2.调用diviner接口获取右侧数据，同时调用我们封装的接口获取左侧数据。
	                3.如果右侧数据没有，隐藏整个楼层，如果左侧数据没有，隐藏左侧
	            */
	
	            //检查是否登录
	            CheckLogin.isLogin({}, function (login) {
	                login = false;
	                var pin = "";
	                if (login === true) {
	                    pin = self.getCookie("pin");
	                }
	
	                var args = {
	                    "pin": pin,
	                    "lim": 12,
	                    "keyword": ""
	                };
	
	                //调用左侧数据接口
	                indexV2Model.getBrowserHistory({}, function (data) {
	                    if (data.isSuccess === true && data.history && data.history.length > 0) {
	                        var leftSideGoods = data.history;
	                        var tpl = __webpack_require__(54);
	                        var leftHtml = tplModel.render({ data: leftSideGoods }, tpl);
	                        $('.guessLike .content').prepend(leftHtml);
	                        priceV2.init('.guessLike');
	                        lazyload.fn.init();
	                    }
	
	                    //调用右侧数据接口
	                    indexV2Model.ajaxRecommend(args, function (ret) {
	                        if (ret.success === true && ret.data && ret.data.length) {
	                            var tpl = __webpack_require__(55);
	                            var rightHtml = tplModel.render({ data: ret.data }, tpl);
	                            $('.guessLike .content').append(rightHtml);
	                            lazyload.fn.init();
	                            priceV2.init('.guessLike');
	
	                            if (!data.isSuccess || !data.history || data.history.length <= 0) {
	                                //隐藏右侧的头
	                                $('.guessLike .like .head').addClass('hide');
	                                setRightItemLength();
	                            }
	
	                            self.initHerizonalScroll();
	                        } else {
	                            //右侧没有数据
	                            $('.guessLike').addClass('hide');
	                        }
	                    });
	                });
	            });
	        },
	        getCookie: function getCookie(name) {
	            var arr,
	                reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
	            if (arr = document.cookie.match(reg)) {
	                return unescape(arr[2]);
	            } else {
	                return null;
	            }
	        }
	    };
	
	    function setRightItemLength() {
	        $('.guessLike .like').css("width", "1210px");
	        $('.guessLike .like .control .scrollbar').css("width", "1090px");
	    }
	
	    module.exports = indexV2Module;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * Created by chenjia on 2016/9/22.
	 */
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var Config = __webpack_require__(3);
	
	    var indexV2Model = {
	        ajaxGetProcess: function ajaxGetProcess(data, _success, error) {
	            if (Config.debug == true) {} else {
	                $.ajax({
	                    url: Config.serviceInterface.getQiangNum,
	                    data: data,
	                    method: 'get',
	                    dataType: 'jsonp',
	                    success: function success(data) {
	                        if (data) {
	                            if ($.isFunction(_success)) {
	                                _success(data);
	                            }
	                        }
	                    }
	                });
	            }
	        },
	        getBrowserHistory: function getBrowserHistory(data, _success2, error) {
	            if (Config.debug == true) {} else {
	                $.ajax({
	                    url: Config.serviceInterface.getBrowserHistory,
	                    data: data,
	                    method: 'get',
	                    dataType: 'jsonp',
	                    success: function success(data) {
	                        if (data) {
	                            if ($.isFunction(_success2)) {
	                                _success2(data);
	                            }
	                        }
	                    }
	                });
	            }
	        },
	        ajaxRecommend: function ajaxRecommend(data, _success3, error) {
	            $.ajax({
	                url: "//diviner.jd.com/diviner?lid=1&lim=" + data.lim + "&ec=utf-8&uuid=&pin=" + data.pin + "&c1=&c2=&c3=&sku=&hi=brand:,price:,keyword:" + data.keyword + "&p=619010",
	                dataType: 'jsonp',
	                jsonpCallback: "jsonpCallback",
	                success: function success(data) {
	                    if ($.isFunction(_success3)) {
	                        _success3(data);
	                    }
	                }
	            });
	        }
	    };
	
	    module.exports = indexV2Model;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var isLoginModel = {
	        isLogin: function isLogin(data, _success, error) {
	            $.ajax({
	                url: "//passport.jd.com/new/helloService.ashx",
	                timeout: 20000,
	                method: 'get',
	                dataType: 'jsonp',
	                success: function success(data) {
	                    if ($.isFunction(_success)) {
	                        var da = true;
	                        if (data.info.indexOf("login()") < 0) {
	                            da = true;
	                        } else {
	                            da = false;
	                        }
	                        _success(da);
	                    }
	                }
	            });
	        }
	    };
	    module.exports = isLoginModel;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tpl = '<div class="history">' + '<div class="head">最近浏览</div>' + '<div class="items">' + '<ul>' + '<% for(var i=0; i<data.length; i++) { %>' + '<li skuid="J_<%= data[i].skuid %>">' + '<a href="//npcitem.jd.hk/<%=data[i].skuid%>.html" target="_blank">' + '<img data-original="<%= data[i].image %>' + '" src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif" class="itemImg lazy">' + '</a>' + '<span class="detail">' + '<a href="//npcitem.jd.hk/<%=data[i].skuid%>.html" target="_blank" class="name"><%= data[i].name %></a>' + '<span class="price">' + '<span></span>' + '</span>' + '</span>' + '</li>' + '<% } %>' + '</ul>' + '</div>' + '</div>';
	    exports.tpl = tpl;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
	    var tpl = '<div class="like">' + '<div class="head">猜你喜欢</div>' + '<div class="items frame" id="frame">' + '<ul id="hScroll" data-items="<%=data.length%>" class="slidee">' + '<% for(var i=0; i<data.length; i++) { %>' + '<li skuid="J_<%= data[i].sku %>">' + '<a href="//npcitem.jd.hk/<%=data[i].sku%>.html" target="_blank">' + '<img data-original="//img13.360buyimg.com/cms/<%= data[i].img %>' + '" src="//img11.360buyimg.com/cms/jfs/t2296/67/2540291745/1095/28285fbe/570e2074Nf22696dd.gif" class="itemImg lazy">' + '<span class="name"><%= data[i].t %></span>' + '<span class="price">' + '<span></span>' + '</span>' + '</a>' + '</li>' + '<% } %>' + '</ul>' + '</div>' + '<% if(data.length > 4) { %>' + '<div class="control">' + '<div class="prev" id="prev">' + '<i></i>' + '</div>' + '<div class="scrollbar" id="scrollbar">' + '<div class="handle">' + '<div class="mousearea"></div>' + '</div>' + '</div>' + '<div class="next" id="next">' + '<i></i>' + '</div>' + '<span class="clr"></span>' + '</div>' + '<% } %>' + '</div>';
	    exports.tpl = tpl;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	!(__WEBPACK_AMD_DEFINE_RESULT__ = function (require, exports, module) {
		var lazyload = __webpack_require__(2);
	
		var nationalEntryModule = {};
	
		nationalEntryModule.init = function () {
			$('.national .national-text li').hover(function () {
				var _this = $(this);
				if (_this.hasClass('active')) {
					return;
				}
				_this.siblings('li.active').removeClass('active');
				var _tag = _this.attr('class');
				var _bg = $('.national .national-bg');
				_bg.find('li.active').removeClass('active');
				_bg.find('li.' + _tag).addClass('active');
				_this.addClass('active');
				_bg.find('img.hideImg').removeClass('hideImg');
				lazyload.fn.init({ "root": $('.national-bg') });
	
				var tt2 = _this.find('.tooltip .tt2');
				if (!tt2.length) {
					_this.find('.tooltip .tt1').css({ lineHeight: '50px', height: '50px' });
				}
			}, function () {});
		};
	
		module.exports = nationalEntryModule;
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// /js/indexV2.js